var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGymAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-5",
    d: "M423.5,436.93c-95.82,55.33-251.18,55.33-347,0C35,413,11.5,382.62,5.92,351.37l269.4-155.53c54.12,3.22,106.73,16.8,148.19,40.74C519.33,291.91,519.33,381.61,423.5,436.93Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "22.16 304.95 24.1 306.11 90.22 267.93 88.28 266.77 22.16 304.95",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.28 266.77 24.1 303.82 24.1 173.84 88.28 136.81 88.28 266.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.89,129.32,20.43,171.73V312.46l73.46-42.41ZM90.22,267.93,24.1,306.11V173.84l66.13-38.17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.22 267.93 88.28 266.77 88.28 136.81 90.22 135.67 90.22 267.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.1 258.34 24.1 260.62 90.22 222.44 88.28 221.28 24.1 258.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.1 212.83 24.1 215.11 90.22 176.93 88.28 175.77 24.1 212.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.89 129.31 91.92 128.19 18.46 170.6 20.43 171.73 93.89 129.31",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.46 170.6 20.43 171.73 20.43 312.46 18.46 311.33 18.46 170.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.38 157.52 54.36 156.38 54.36 288.65 52.38 287.52 52.38 157.52",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "58.03 154.27 54.36 156.38 54.36 288.65 58.03 286.52 58.03 154.27",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.89 174.82 93.89 179.05 20.43 221.46 20.43 217.23 93.89 174.82",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.89 220.32 93.89 224.55 20.43 266.96 20.43 262.73 93.89 220.32",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.36 197.64 52.38 196.5 24.1 212.83 24.1 215.11 54.36 197.64",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.36 243.13 52.38 241.99 24.1 258.32 24.1 260.6 54.36 243.13",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "115.59 251.01 117.53 252.17 183.65 213.99 181.71 212.83 115.59 251.01",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.71 212.83 117.53 249.88 117.53 119.9 181.71 82.87 181.71 212.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.32,75.38l-73.46,42.41V258.52l73.46-42.41ZM183.65,214l-66.12,38.18V119.9l66.12-38.17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.65 213.99 181.71 212.83 181.71 82.87 183.65 81.73 183.65 213.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.53 204.4 117.53 206.68 183.65 168.5 181.71 167.34 117.53 204.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.53 158.89 117.53 161.17 183.65 122.99 181.71 121.83 117.53 158.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.32 75.38 185.35 74.25 111.89 116.66 113.86 117.79 187.32 75.38",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.89 116.66 113.86 117.79 113.86 258.52 111.89 257.39 111.89 116.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.81 103.58 147.78 102.44 147.78 234.71 145.81 233.58 145.81 103.58",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "151.45 100.33 147.78 102.44 147.78 234.71 151.45 232.58 151.45 100.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.32 120.88 187.32 125.11 113.86 167.52 113.86 163.29 187.32 120.88",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.32 166.38 187.32 170.61 113.86 213.02 113.86 208.79 187.32 166.38",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.78 143.7 145.81 142.56 117.53 158.89 117.53 161.17 147.78 143.7",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.78 189.19 145.81 188.05 117.53 204.38 117.53 206.66 147.78 189.19",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "209.01 197.07 210.96 198.23 277.08 160.05 275.13 158.89 209.01 197.07",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.13 158.89 210.96 195.94 210.96 65.96 275.14 28.93 275.13 158.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.75,21.44,207.29,63.85V204.58l73.46-42.41Zm-3.67,138.61L211,198.23V66l66.12-38.17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.08 160.05 275.13 158.89 275.14 28.93 277.08 27.79 277.08 160.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.96 150.46 210.96 152.74 277.08 114.56 275.13 113.41 210.96 150.46",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.96 104.95 210.96 107.23 277.08 69.05 275.13 67.89 210.96 104.95",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.75 21.43 278.77 20.3 205.31 62.72 207.29 63.85 280.75 21.43",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.31 62.72 207.29 63.85 207.29 204.58 205.31 203.45 205.31 62.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.24 49.64 241.21 48.5 241.21 180.77 239.24 179.64 239.24 49.64",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "244.88 46.39 241.21 48.5 241.21 180.77 244.88 178.64 244.88 46.39",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.75 66.94 280.75 71.17 207.29 113.58 207.29 109.35 280.75 66.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.75 112.44 280.75 116.67 207.29 159.08 207.29 154.85 280.75 112.44",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.21 89.76 239.24 88.62 210.96 104.95 210.96 107.23 241.21 89.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.21 135.25 239.24 134.11 210.96 150.44 210.96 152.72 241.21 135.25",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Poster--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--poster--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--poster--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "412.48 32.23 473.17 67.33 473.17 173.02 412.48 137.92 412.48 32.23",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.14,80.06c0-5.41-5.06-14.52-7.12-15.72L411,33.65V138.76l60.19,34.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.64,162.3,417,134.72V44.05l47.69,27.58ZM418,134.14l45.69,26.43V72.21L418,45.78Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.2,34.08l52.69,30.48c1.8,1,7,9.87,7,15.5v93.07L411.2,138.61V34.08m-.5-.87V138.9L471.39,174V80.06c0-5.58-5.19-14.74-7.25-15.93L410.7,33.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.14,64.13c3.34,2.7.87,9.52.87,9.52s6.38-.17,6.38,6.83h0C471.39,70.79,468.1,66.41,464.14,64.13Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.84,62.69v1.47l.85.74v6.45h0l-3.19-10-1.58-.92-.84-.48v1.47l.84.73v8.73l-.84-.24v1.47L425.32,74V72.5l-.85-.74V65.3h0l3.19,10,1.58.91V65.81l.85.24V64.58l-.85-.49ZM435.6,78l-2.55-1.47V73.09l2.67,1.54V72.75l-2.67-1.54V68.15l2.53,1.46.07,1.49,1.21.7V68.47l-5.39-3.11-.84-.49v1.47l.84.74V75.8l-.84-.23V77l6.24,3.61V77.31l-1.2-.69Zm6.71-4.94.6.51-1.41,6.5-.09.59h0l-.1-.73-1.4-8.1.61.18V70.56L437.6,68.9v1.47l.65.51,2.33,11.9,1.63.94,2.33-9.21.66.25V73.29l-2.89-1.67Zm8.34,13.63-2.55-1.47V81.78l2.68,1.54V81.44L448.1,79.9V76.84l2.53,1.46.07,1.5,1.22.7V77.16l-5.4-3.11-.84-.49V75l.84.74V84.5l-.84-.24v1.46l6.25,3.61V86l-1.2-.7Zm9.05,5.58a1,1,0,0,1-.35-.46,2.22,2.22,0,0,1-.1-.68v-.62a6.14,6.14,0,0,0-.31-2,4.26,4.26,0,0,0-1-1.63,1.24,1.24,0,0,0,.94-.56,2.58,2.58,0,0,0,.32-1.41,6.26,6.26,0,0,0-.77-3.06,5.55,5.55,0,0,0-2.11-2.16l-2.7-1.56-.85-.49v1.47l.85.74v8.72l-.85-.23v1.46l3.28,1.89V90.24l-.85-.73V86.3l1.3.75a2.21,2.21,0,0,1,.86,1,3.81,3.81,0,0,1,.31,1.56v.7a5.11,5.11,0,0,0,.31,1.84,2.42,2.42,0,0,0,1.09,1.27l.82.48V92.46Zm-2.41-7.11c-.22.16-.55.12-1-.14l-1.09-.63V80.94l1.12.65a2.33,2.33,0,0,1,1,1,3.43,3.43,0,0,1,.33,1.5C457.62,84.68,457.51,85,457.29,85.19Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.21,88.71l.93.64V91a.89.89,0,0,1-.38,0,2.17,2.17,0,0,1-.63-.27,3.12,3.12,0,0,1-1.33-1.67,7.2,7.2,0,0,1-.46-2.68v-.36a4.08,4.08,0,0,1,.47-2.25c.31-.46.75-.52,1.31-.2a2.9,2.9,0,0,1,.67.53,3.09,3.09,0,0,1,.47.64l.18,1.43,1,.56v-2a7.2,7.2,0,0,0-1-1.61A5.38,5.38,0,0,0,425,82a1.53,1.53,0,0,0-2.12.18,4.88,4.88,0,0,0-.8,3.16v.34a9.55,9.55,0,0,0,.82,4A5.34,5.34,0,0,0,425,92.24a2.94,2.94,0,0,0,1.53.5,1.51,1.51,0,0,0,.92-.33V88.59l-2.23-1.28Zm2.87-3.56.69.6v7.13l-.69-.19v1.19l2.67,1.55v-1.2l-.69-.6V86.5l.69.19v-1.2L428.08,84Zm6.92,4,.48.42-1.14,5.31-.08.49,0,0-.08-.59L433,88.13l.49.15v-1.2l-2.36-1.36v1.2l.54.42,1.9,9.72,1.33.77,1.9-7.53.54.2V89.3L435,87.94Zm6.87,10-.06,1.15-2.08-1.2V96.24l2.19,1.26V96l-2.19-1.26v-2.5l2.07,1.19.05,1.22,1,.58V92.47l-4.41-2.54-.69-.4v1.2l.69.6v7.13l-.69-.19v1.2l5.11,2.94V99.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.19,95.56v1.2l-.7-.2v5.19a3.71,3.71,0,0,0,.35,1.67,2.42,2.42,0,0,0,.94,1c.4.23.72.25,1,.06a1.66,1.66,0,0,0,.35-1.27V98.05l-.69-.6v-1.2l2.67,1.54V99l-.69-.2V104c0,1.11-.24,1.83-.71,2.16a1.72,1.72,0,0,1-1.88-.17,5,5,0,0,1-1.87-2,6.23,6.23,0,0,1-.71-3V95.82l-.69-.61V94l.69.4,1.29.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.52,99.79a4.35,4.35,0,0,1,1.74,1.88,5.75,5.75,0,0,1,.64,2.67,2.32,2.32,0,0,1-.64,1.92c-.42.33-1,.29-1.74-.14l-1.09-.63v2.2l.69.61v1.19L452.44,108v-1.19l.69.19V99.82l-.69-.6V98l.69.39ZM454.43,104l1.09.63c.36.2.63.21.81,0a1.38,1.38,0,0,0,.28-1,3.23,3.23,0,0,0-.28-1.35,1.93,1.93,0,0,0-.81-.94l-1.09-.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.89,108.82l-1.29-.74v-6.51l1.29.74Zm0,3.43-1.29-.75v-1.74l1.29.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.78,125.46a12.76,12.76,0,0,0-1.2-5.19,9.09,9.09,0,0,0-1.25-1.94,6.39,6.39,0,0,0-1.75-1.34,6.2,6.2,0,0,1-1.8-1.57c-.47-.58-.9-1.21-1.35-1.82a5.6,5.6,0,0,0-2.92-2.46,2.26,2.26,0,0,1-1.09-.41,4.69,4.69,0,0,1-.89-1.09l-.17-.31-.35-.61a10.91,10.91,0,0,0-.76-1.15,5.6,5.6,0,0,0-.49-.57,2.54,2.54,0,0,0-2.36-1s-.07,0-.06.08a.19.19,0,0,0,.07.13.25.25,0,0,0,.11,0A2.67,2.67,0,0,1,439,107a7.53,7.53,0,0,1,1.31,1.6c.16.26.32.52.47.79l.31.56.18.3a4.63,4.63,0,0,0,.39.56l.19.23.24.26a2,2,0,0,0,.26.24,3.14,3.14,0,0,0,1.53.6,2.74,2.74,0,0,1,1.34.89c.88.94,1.58,2.21,2.42,3.22a7.07,7.07,0,0,0,1.32,1.26c.35.25.71.43,1.06.65a.66.66,0,0,0-.52.15,2.52,2.52,0,0,1-.33.24,1.37,1.37,0,0,0-.3.19s0,.18,0,.21a1,1,0,0,0,.76,0,1.1,1.1,0,0,1,.76,0,5,5,0,0,1,.77.43,1.5,1.5,0,0,1,.23.15,9.36,9.36,0,0,1,1.2,3.07,19.91,19.91,0,0,1,.31,4.74,27.34,27.34,0,0,1-.42,4.37,10.87,10.87,0,0,1-1.31,3.84c-.27.39-.68.77-1.23.31a4.46,4.46,0,0,1-1.06-1.75c0-.43,0-.89,0-1.29v-.72c.09-.08.07-.32.08-.48s0-.51.06-.76a6.45,6.45,0,0,1,.29-1.39c0-.07-.06-.33-.11-.22a5.71,5.71,0,0,0-.33,1c0-1,0-2-.13-3.07,0-.64-.12-1.27-.13-1.9,0-.47,0-.94,0-1.42,0-1-.09-2-.16-3,0-.12-.08-.16-.08,0,0,.93,0,1.84,0,2.78,0,.48,0,1,0,1.43s-.06,1-.09,1.5c-.12,1.88-.22,3.77-.32,5.65,0,.43,0,.87-.05,1.3a4.24,4.24,0,0,1-.11,1.16c-.23.56-1.17,0-1.62-.22a9.89,9.89,0,0,1-1.84-1.14,3.26,3.26,0,0,1-1-1.23c0-.11,0-.22,0-.32.06-1,.07-2.1.08-3.16a35,35,0,0,0-.44-6.28c-.19-1.08-.41-2.16-.71-3.26a12.06,12.06,0,0,0-.58-1.69c-.3-.69-.57-1.42-.91-2.08,0-.07-.05,0,0,.06.15.45.32.89.43,1.34s.17.85.27,1.27c.21.91.43,1.8.58,2.7a37.57,37.57,0,0,1,.48,5.39c.06,1.81,0,3.58-.09,5.3a1.63,1.63,0,0,1-.15.77c-.17.23-.52,0-.78-.15a20.09,20.09,0,0,1-2-1.13,2.89,2.89,0,0,1-1.41-1.93,17.31,17.31,0,0,1-.3-3.22.29.29,0,0,0,0-.09,12.67,12.67,0,0,0-.54-5.62,42.61,42.61,0,0,0-2.24-6.74c-.1-.22-.24-.18-.17.05,1.07,3.51,2.65,7.63,2.35,10.83a2.62,2.62,0,0,1-1,2c-.12,0-.23,0-.35,0a2.52,2.52,0,0,1-.6,0,4.41,4.41,0,0,1-.74-.22l-.3-.13-.29-.1c-.08,0-.06.18,0,.23a3.45,3.45,0,0,0,.64.48,4.59,4.59,0,0,0,.5.24,1.53,1.53,0,0,1-1.41-.12,4.44,4.44,0,0,1-1.12-2q-1-2.68-1.8-5.42c-.27-.89-.54-1.79-.74-2.68a5.62,5.62,0,0,1-.08-2.53,4.27,4.27,0,0,0-.18-2.28,8.86,8.86,0,0,1-.54-2.35,8.68,8.68,0,0,1,.89-3.76,2.09,2.09,0,0,1,.82-1.11c.51-.24,1.1.22,1.68.73,1.21,1.06,2.64,2.35,3.67,1.73.15-.09-.1-.62-.26-.65a3.66,3.66,0,0,1-2.11-1,17.91,17.91,0,0,0-1.95-1.8c-1.26-.82-2.13-.16-2.67.94a10,10,0,0,0-1,4,7.5,7.5,0,0,0,.39,2.66A11.09,11.09,0,0,1,429,112a3,3,0,0,1-.1,1.32,8.14,8.14,0,0,0,.29,3.36,4.11,4.11,0,0,0-.1.41,5.1,5.1,0,0,1-.14.7,10,10,0,0,1-.51,1.46,6.42,6.42,0,0,0-.72,2.56,10.8,10.8,0,0,0,.81,3.37c.42,1.25.82,2.53,1.3,3.77a7,7,0,0,0,4.28,4.13,29.58,29.58,0,0,1,2.7,1.25,23.41,23.41,0,0,0,2.53,1.51c.74.27,1.21-.11,1.4-.95a6.67,6.67,0,0,0,.16-2.24c.61.37,1.29.76,1.78.63a.77.77,0,0,0,.48-.5,6,6,0,0,0,1.25,1.42,9.46,9.46,0,0,0,1.88,1.23,4,4,0,0,0,1.59.53c.43,0,.67-.28.81-.71a3.57,3.57,0,0,0,1.7,1.88c1.22.44,1.81-1,2.23-2.13A24.83,24.83,0,0,0,453.78,125.46Zm-13.69,8.68a1.15,1.15,0,0,1-.38.74c-.27.16-.66-.08-1-.3-.73-.48-1.45-1-2.18-1.37-.51-.26-1-.49-1.51-.71,0-.14,0-.27,0-.41v-.53a8,8,0,0,1,0-1c0-.2.08-.3.25-.25a3.62,3.62,0,0,1,.4.19,9.12,9.12,0,0,1,.85.48,12.55,12.55,0,0,1,1.42,1c.21.19.43.36.64.58a5.06,5.06,0,0,1,.44.57,2.16,2.16,0,0,0,.21.29s0,0,0-.07a4.89,4.89,0,0,0-1.24-2,9,9,0,0,0-1.84-1.38,7.12,7.12,0,0,0-1-.51c-.3-.11-.54-.08-.61.31a6.43,6.43,0,0,0,0,1.25,6.71,6.71,0,0,0,.07.76,5.35,5.35,0,0,0,.11.55l-.64-.28a7.17,7.17,0,0,1-2.2-1.23,5.89,5.89,0,0,1-1.55-2.63l-1.16-3.44a6.79,6.79,0,0,1-.58-2.92,13.25,13.25,0,0,1,.89-2.51,7.91,7.91,0,0,0,.21-.9c.06.2.12.39.17.58q.5,1.65,1.05,3.3a1.87,1.87,0,0,0-.78-.29.75.75,0,0,0-.47.09.47.47,0,0,0-.32.38.25.25,0,0,0,0,.14.24.24,0,0,0,.21,0h.22a2.58,2.58,0,0,1,.59.12,2.86,2.86,0,0,1,.44.2l.05,0,0,0,.1.07.06,0a2.39,2.39,0,0,0-.13.28,2.2,2.2,0,0,0-.12.61c0,.21,0,.43,0,.65s.1.52.15.78.11.13.11,0a.78.78,0,0,1,0-.27c0-.12.05-.24.08-.36a2.92,2.92,0,0,1,.13-.42c0-.13.08-.26.13-.38l0-.06.36,1a5.74,5.74,0,0,0,1.39,2.27,2.06,2.06,0,0,0,1.76.53,3.46,3.46,0,0,0,2-.92,6.36,6.36,0,0,0,1.3,4,6.73,6.73,0,0,0,1.87,1.38A5.61,5.61,0,0,1,440.09,134.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.4,109.07c-.33,0-.52.46-.61.87a3,3,0,0,0,0,.75c0,.38.13.76.2,1.15,0,.12.11.15.11,0,0-.27,0-.55,0-.81a3.5,3.5,0,0,1,.09-.67,1.44,1.44,0,0,1,.21-.43,2.87,2.87,0,0,0,.29-.31C440.78,109.5,440.56,109.06,440.4,109.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.77,109.63a2.56,2.56,0,0,0,0-.27,2.17,2.17,0,0,1-.07-.24c0-.07,0-.13,0-.2a1.21,1.21,0,0,0-.05-.14,3,3,0,0,0-.2-.4,3.52,3.52,0,0,0-.3-.45,2.41,2.41,0,0,0-.3-.33,1.12,1.12,0,0,0-.49-.28c-.13,0-.18.13-.11.32a.89.89,0,0,0,.15.29,1.25,1.25,0,0,0,.19.15l.19.17h0l.06.06.07.09,0,0a1.22,1.22,0,0,0,.12.19l.13.21a.31.31,0,0,1,0,.1l.09.13.21.46a5,5,0,0,1,.2.54c0,.08.08.2.14.21s.08-.08.06-.16S434.79,109.79,434.77,109.63Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-5",
    cx: 425.78,
    cy: 238.98,
    rx: 33.15,
    ry: 19.14,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-5",
    points: "251.67 337.63 312.6 302.45 207.03 241.5 146.1 276.67 251.67 337.63",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-5",
    points: "342.27 285.37 403.2 250.19 297.63 189.23 236.7 224.41 342.27 285.37",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M175.44,393.29l32.35-18.68a1.11,1.11,0,0,0,0-2.11L141.15,334a4,4,0,0,0-3.65,0l-32.35,18.68a1.11,1.11,0,0,0,0,2.11l66.64,38.47A4,4,0,0,0,175.44,393.29Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M103.46,434.85l32.35-18.68a1.11,1.11,0,0,0,0-2.11L69.17,375.59a4.07,4.07,0,0,0-3.66,0L33.17,394.27a1.11,1.11,0,0,0,0,2.11L99.8,434.85A4.07,4.07,0,0,0,103.46,434.85Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M229.49,325.5c2.95,1.7,2.95,4.47,0,6.18a11.84,11.84,0,0,1-10.72,0c-3-1.71-3-4.48,0-6.18A11.84,11.84,0,0,1,229.49,325.5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M161.49,391.71a9.41,9.41,0,0,1-8.49,0c-2.35-1.35-2.35-3.55,0-4.9a9.34,9.34,0,0,1,8.49,0C163.83,388.16,163.83,390.36,161.49,391.71Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M313.26,439l-2.42-1.39c-1.64-.95-1.64-2.48,0-3.43l5.38-3.1-58.08-33.61-5.38,3.11a6.55,6.55,0,0,1-5.94,0l-2.41-1.39c-1.64-.95-1.64-2.48,0-3.43l16.33-9.43a6.59,6.59,0,0,1,5.93,0l2.42,1.4c1.64.94,1.64,2.48,0,3.42l-5.95,3.44,58.09,33.6,5.94-3.44a6.59,6.59,0,0,1,5.93,0l2.42,1.4c1.64.94,1.64,2.48,0,3.42L319.19,439A6.53,6.53,0,0,1,313.26,439Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M441.25,306c4.82,2.79,4.82,7.3,0,10.09s-12.65,2.78-17.47,0-4.82-7.3,0-10.09S436.43,303.17,441.25,306Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M458.18,309.34c4,2.31,4,6.05,0,8.36a16,16,0,0,1-14.49,0c-4-2.31-4-6.05,0-8.36A16,16,0,0,1,458.18,309.34Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ball--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--ball--inject-5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 428.62,
    cy: 220.41,
    r: 30.19,
    transform: "matrix(0.55, -0.83, 0.83, 0.55, 8.6, 456.8)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.54,197c-.3,1.46-1.53,2.62-3.49,3.28a14.37,14.37,0,0,1-12.73-2.56c-1.55-1.36-2.24-2.91-1.94-4.37a4.46,4.46,0,0,1,3-3.09c.64,0,1.29,0,1.94,0a10.29,10.29,0,0,0-1.3.33c-1.77.6-2.88,1.62-3.14,2.89s.38,2.64,1.78,3.87a13.79,13.79,0,0,0,12.22,2.45c1.76-.6,2.88-1.62,3.13-2.88s-.38-2.64-1.78-3.87a9.24,9.24,0,0,0-1.41-1c.65.23,1.28.48,1.9.75C442.17,194.08,442.82,195.58,442.54,197Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M456.22,232.63l0-.1h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M401.54,207.07l-.14.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M455.85,233.44c-.06.15-.14.29-.21.43C455.71,233.73,455.79,233.59,455.85,233.44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M400,230a20.88,20.88,0,0,0,4.59,5.55c9.85,8.66,28,12.3,40.4,8.11a20.76,20.76,0,0,0,6.38-3.35c-.55.63-1.13,1.24-1.73,1.82a23.51,23.51,0,0,1-4.49,2c-6.29,2.13-14,2.27-21.43.78s-14.49-4.6-19.48-9a23.71,23.71,0,0,1-3.35-3.6C400.55,231.53,400.25,230.74,400,230Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M405.3,226.44c10.36,9.12,29.43,12.95,42.5,8.54,5-1.68,8.49-4.33,10.19-7.63-.14.6-.29,1.19-.47,1.77h0c-2,2.71-5.23,4.9-9.55,6.36-6.62,2.23-14.75,2.38-22.54.82s-15.23-4.85-20.47-9.46c-3.43-3-5.59-6.3-6.36-9.56.06-.6.15-1.2.25-1.8C399.15,219.18,401.37,223,405.3,226.44Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M398.47,222c0,.12,0,.24,0,.37C398.49,222.19,398.48,222.07,398.47,222Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M410.89,196l-.27.2C410.7,196.11,410.8,196.05,410.89,196Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M447.93,217.26c-5.52,1.87-12.31,2-18.81.68s-12.72-4-17.09-7.89c-3.62-3.18-5.54-6.72-5.57-10.14.17-.19.36-.37.54-.56-.19,3.44,1.68,7.05,5.37,10.31,8.63,7.59,24.5,10.78,35.39,7.1,4.67-1.57,7.79-4.19,8.94-7.43.09.24.19.48.28.73C455.63,213.2,452.49,215.72,447.93,217.26Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M458.68,217.55c-1.33,3.83-5,6.9-10.38,8.73-6.17,2.08-13.75,2.22-21,.76s-14.2-4.51-19.09-8.81c-4.3-3.79-6.46-8-6.2-12.07.22-.41.46-.81.69-1.21-.84,4.24,1.24,8.81,5.86,12.88,9.65,8.49,27.41,12.06,39.58,7.95,5.83-2,9.52-5.38,10.38-9.62.07.46.12.92.17,1.38Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M458.78,219c0-.19,0-.39,0-.58C458.76,218.6,458.77,218.8,458.78,219Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M411.74,195.39l.27-.18Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M445.34,208.23a31,31,0,0,1-27.44-5.51c-3-2.67-4.51-5.67-4.24-8.52l.58-.33c-.44,2.79,1,5.78,4,8.46,6.56,5.77,18.64,8.2,26.92,5.4,3.84-1.29,6.29-3.51,7-6.25l.4.52C451.69,204.74,449.17,206.94,445.34,208.23Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M454.6,205l-.21-.35Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M453.66,203.55l.22.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M436.32,237.69c18-6.9,20.66-20.17,19.24-30.86h0a30.18,30.18,0,1,1-57,16.83C400,232.92,418.35,244.59,436.32,237.69Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mat--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mat--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "477.09 371.32 368.91 433.78 312.64 401.33 420.82 338.87 477.09 371.32",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.09 371.32 368.91 433.78 312.64 401.33 420.82 338.87 477.09 371.32",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.09 371.32 477.09 372.3 368.91 434.76 368.91 433.78 477.09 371.32",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.09 371.32 477.09 372.3 368.91 434.76 368.91 433.78 477.09 371.32",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.91 433.78 312.64 401.33 312.64 402.31 368.91 434.76 368.91 433.78",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.91 433.78 312.64 401.33 312.64 402.31 368.91 434.76 368.91 433.78",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Kettlebells--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Kettlebell--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.09,296.4c-4.32-.22-9.95,3.85-10.23,9.22a9.75,9.75,0,0,0,1.9,6.31h0a5.22,5.22,0,0,0,.54.66,6.45,6.45,0,0,0,1.11.89,12.79,12.79,0,0,0,11.55.61,6.91,6.91,0,0,0,1.2-.78,4.8,4.8,0,0,0,.6-.59v0a9.66,9.66,0,0,0,2.54-6.07C442.6,301.27,437.42,296.63,433.09,296.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.3,312.6a5.22,5.22,0,0,1-.54-.66h0a9.63,9.63,0,0,1-1.28-2.36c.17.17,4.77,4.73,10.61,2.08s6.45-11.6,1.94-14.48c3.42,1.56,6.5,5.29,6.28,9.47a9.66,9.66,0,0,1-2.54,6.07v0a4.8,4.8,0,0,1-.6.59,6.91,6.91,0,0,1-1.2.78,12.79,12.79,0,0,1-11.55-.61A6.45,6.45,0,0,1,425.3,312.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.16,303.36a1.08,1.08,0,0,0,.92,1,1.1,1.1,0,0,0,1.26-.91l.51-3.24,0-.12a11.27,11.27,0,0,0-1.94-1.78l0,.16-.74,4.64A1.22,1.22,0,0,0,437.16,303.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.69,288.17l1.75,10a10.93,10.93,0,0,1,2-1.05l-1.63-9.63v0h0l9.22,4.91a3.05,3.05,0,0,1,1.42,2.86l-.31,2-.18,1.05,0,.16-.74,4.64a1.22,1.22,0,0,0,0,.27,1.08,1.08,0,0,0,.92,1,1.1,1.1,0,0,0,1.26-.91l.51-3.24,0-.12.26-1.63.45-2.84a5.19,5.19,0,0,0-2.55-5.13l-9.21-4.92a2.27,2.27,0,0,0-2.69,0C425.75,285.85,425.19,286.61,425.69,288.17Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--kettlebell--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.61,302c-3.35-.09-7.61,3.16-7.72,7.31a7.5,7.5,0,0,0,1.59,4.84h0a3.27,3.27,0,0,0,.43.5,4.75,4.75,0,0,0,.87.67,9.87,9.87,0,0,0,8.93.24,4.66,4.66,0,0,0,.91-.62,3.28,3.28,0,0,0,.45-.47h0a7.49,7.49,0,0,0,1.85-4.74C459,305.57,455,302.09,451.61,302Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.91,314.65a3.27,3.27,0,0,1-.43-.5h0a7.67,7.67,0,0,1-1-1.8c.14.13,3.78,3.56,8.24,1.4s4.75-9.08,1.21-11.22c2.67,1.14,5.12,4,5,7.19a7.49,7.49,0,0,1-1.85,4.74h0a2.81,2.81,0,0,1-.45.47,4.66,4.66,0,0,1-.91.62,9.87,9.87,0,0,1-8.93-.24A4.75,4.75,0,0,1,445.91,314.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.89,307.29a.83.83,0,0,0,.73.74.85.85,0,0,0,.95-.73l.33-2.51v-.09a8.81,8.81,0,0,0-1.53-1.34v.12l-.48,3.6A.74.74,0,0,0,454.89,307.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.73,295.79l1.55,7.68a9.66,9.66,0,0,1,1.49-.85l-1.45-7.4h0l7.2,3.61A2.33,2.33,0,0,1,455.7,301l-.21,1.54-.11.82v.12l-.48,3.6a.74.74,0,0,0,0,.21.83.83,0,0,0,.73.74.85.85,0,0,0,.95-.73l.33-2.51v-.09l.17-1.26.29-2.21a4,4,0,0,0-2.06-3.91l-7.21-3.62a1.77,1.77,0,0,0-2.08,0C445.73,294,445.31,294.6,445.73,295.79Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Barbell--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--barbell--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.91,369.33h0c-1.86-6.08-9.24-9.14-13.62-7.54h0a13.06,13.06,0,0,0-3.2,1.36c-6.89,4-12.48,13.65-12.48,21.61a13.12,13.12,0,0,0,.56,3.95h0c1.13,3.89,6.52,9.5,13.63,7.52h0a13.22,13.22,0,0,0,3.2-1.36c6.89-4,12.47-13.65,12.47-21.61A13,13,0,0,0,272.91,369.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,394.86c6.89-4,12.47-13.65,12.47-21.61S267.88,362.07,261,366s-12.48,13.65-12.48,21.61S254.1,398.84,261,394.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.65,376.2c1.83-1.06,3.32-.2,3.32,1.91a7.33,7.33,0,0,1-3.32,5.74c-1.83,1.06-3.31.2-3.31-1.91A7.33,7.33,0,0,1,260.65,376.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,379.37a2.55,2.55,0,0,1-1.13,2,.85.85,0,0,1-.77.1l-.08-.05a.83.83,0,0,1-.29-.71,2.53,2.53,0,0,1,1.14-2,.81.81,0,0,1,.75-.1l.09.05A.83.83,0,0,1,261.79,379.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.65,411.12a2.5,2.5,0,0,1-1.14,2,.92.92,0,0,1-.49.15.79.79,0,0,1-.38-.11l-54.75-31.68-.08-.05a.83.83,0,0,1-.29-.71,2.53,2.53,0,0,1,1.14-2,.81.81,0,0,1,.75-.1l.09.05,54.75,31.68A.81.81,0,0,1,316.65,411.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.42,407.22h0c-1.86-6.08-9.24-9.13-13.62-7.54h0a13.69,13.69,0,0,0-3.2,1.37c-6.89,4-12.48,13.64-12.48,21.6a13.12,13.12,0,0,0,.56,4h0c1.14,3.89,6.52,9.51,13.63,7.52h0a13.69,13.69,0,0,0,3.2-1.37c6.89-4,12.47-13.65,12.47-21.61A13,13,0,0,0,338.42,407.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5,432.75c6.89-4,12.47-13.65,12.47-21.61s-5.58-11.18-12.47-7.2S314,417.58,314,425.54,319.61,436.73,326.5,432.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.16,414.09c1.83-1,3.32-.2,3.32,1.92a7.31,7.31,0,0,1-3.32,5.73c-1.82,1.06-3.31.2-3.31-1.91A7.36,7.36,0,0,1,326.16,414.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.3,417.26a2.53,2.53,0,0,1-1.13,2,.82.82,0,0,1-.77.1l-.08-.05a.83.83,0,0,1-.29-.71,2.5,2.5,0,0,1,1.14-2,.78.78,0,0,1,.75-.1l.09,0A.83.83,0,0,1,327.3,417.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,418.85a2.51,2.51,0,0,1-1.13,2,.94.94,0,0,1-.49.15.73.73,0,0,1-.38-.11l-2.64-1.52-.08-.05a.83.83,0,0,1-.29-.71,2.5,2.5,0,0,1,1.14-2,.78.78,0,0,1,.75-.1l.09,0,2.63,1.52A.79.79,0,0,1,330,418.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,418.84a2.55,2.55,0,0,1-1.13,2,.83.83,0,0,1-.76.1l-.09-.05a.83.83,0,0,1-.29-.71,2.53,2.53,0,0,1,1.14-2,.83.83,0,0,1,.76-.1l.08.05A.83.83,0,0,1,330,418.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.07,357.1c-1,1.56-3.42,2.81-8.63,1.09s-5.85-6.45-4.67-7.83c2.19-2.53,10.76-4.85,13.42-2.28S374.4,355,373.07,357.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.27,366.1c-.83,3.3-8.21,1.56-11.78.56-2.6-.73-4.73-2.48-4.51-3.92.38-2.48,3.78-6.78,7.86-5S397,363.24,396.27,366.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.76,330.85c1.91,4.79,2.33,8.87,1.19,13.06s-6,19.77-6.4,22.72c-.23,1.49,0,1.72.95,3.81s1.91,4.72,2.06,10c.12,4.27,0,9-.1,12.17l-.09.61s.21,5.74-2.48,6.17-4.62-2.22-4.62-2.22-1-4.67-3.33-11.52c-2.36-7.11-4.84-12.5-6.05-16.35s-1.12-3.82-.67-10.67c.33-5,2.1-15.89,2.1-15.89Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.76,395c0-.55.38-2.23-.3-2.4l-.09.61s-.37.68-3.27.95a12.4,12.4,0,0,1-4.66-.25l-.28-1s-.25.09-.15.83,1.23,3.09,1.17,4.05.71,2.57,4.49,2.16,3.39-4.37,3.39-4.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.68,410.43c-.08.51,0,.86,1.85,1.5a13.58,13.58,0,0,0,7.05,0,10.26,10.26,0,0,0,5.39-4.17,13.42,13.42,0,0,1,4.32-3.6c1.33-.74,1.61-1,1.5-1.46s-.5-1.59-.5-1.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.43,399.24c-.34-1.45-1-2.11-1-3.3s-.66-1-.66-1l-.06.67c-.06.44-.32.62-.53,1-.47.77-.46,1.31-1.11,1.54s-.77-.88-1.5-.87a1.07,1.07,0,0,0-.72.38,1.94,1.94,0,0,0,0-.92c-.21-.7-2.65-.94-3.92-1.15s-.69.68-1.12,1.89a38.17,38.17,0,0,1-4.08,6.47,37.31,37.31,0,0,1-3.06,2.58c-1.51,1.09-1.38,1.56-1.82,1.85s-.53,1.31-.29,1.92,3.76,2.05,7.46,1.17a8.34,8.34,0,0,0,6-4.42,10.16,10.16,0,0,1,3.83-3.52,8.39,8.39,0,0,0,2.57-1.81A5,5,0,0,0,400.43,399.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.75,404a38.17,38.17,0,0,0,4.08-6.47c.43-1.21-.14-2.1,1.12-1.89s3.71.45,3.92,1.15-.37,2.38-1.71,4.44a22.24,22.24,0,0,1-4,4.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.15,409c.68.16,1.41.32,1.44.57a5.77,5.77,0,0,0,.44,2.12,1.79,1.79,0,0,0,1.46.62,17.85,17.85,0,0,0,5-.49,9.29,9.29,0,0,0,4.46-3c1.4-1.63,1.64-2.41,3.49-3.66a35.76,35.76,0,0,0,3.35-2.22,3.44,3.44,0,0,1,.16.58,2.28,2.28,0,0,1-.84.71,22.55,22.55,0,0,0-3.45,2.07,26.24,26.24,0,0,0-2.49,2.89,9.5,9.5,0,0,1-4.66,3,13.75,13.75,0,0,1-6.89,0c-1.9-.63-2-1-2.16-1.23a4.23,4.23,0,0,1-.15-1.85C380.42,408.87,380.67,408.9,381.15,409Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.75,404.79a6.79,6.79,0,0,0-3.7-1.21,1.11,1.11,0,0,0-.49.55,8.59,8.59,0,0,1,3.61,1.23S389.72,405.29,389.75,404.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.07,402.16a10.66,10.66,0,0,1,4.32,1.34.68.68,0,0,0,.55-.56s-2.63-1.52-4.48-1.37C387.46,401.57,387,401.8,387.07,402.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.35,400.19c.82-.32,3.85.89,4.56,1.52a.59.59,0,0,0,.55-.63s-2.59-1.76-4.66-1.64C388.8,399.44,388.23,399.7,388.35,400.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.43,398.32c.41-.08,3.38.09,4.77,1.29a.73.73,0,0,0,.43-.67,7.85,7.85,0,0,0-4.85-1.33A1.1,1.1,0,0,0,389.43,398.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.09,323.78c1.53,4.93,13.71,12.88,12.26,17s-9.79,11.58-13.82,14.88c-.34,1.47-.15,1.71.66,3.88a23.57,23.57,0,0,1,1.3,10.08c-.21,4.27-.71,9-1,12.13l-.14.6s-.23,5.74-2.94,6S366,385.7,366,385.7s-.7-4.73-2.45-11.73c-1.81-7.27-2.46-10.93-3.37-14.86s-1.73-5.68,1.21-10.56c2.27-3.77,12.08-19.29,12.08-19.29Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.58,384.12c.08-.54.55-2.19-.11-2.41l-.14.6s-.42.65-3.33.7a12.39,12.39,0,0,1-4.63-.6l-.2-1.05s-.26.07-.22.82,1,3.17.86,4.12.52,2.62,4.32,2.49,3.71-4.09,3.71-4.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.37,398.17c-.11.5-.08.85,1.74,1.63a13.6,13.6,0,0,0,7,.52,10.27,10.27,0,0,0,5.69-3.75,13.45,13.45,0,0,1,4.59-3.27c1.38-.63,1.67-.89,1.6-1.34s-.38-1.62-.38-1.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.92,388.5c-.23-1.47-.83-2.17-.75-3.35s-.59-1-.59-1l-.11.67c-.09.43-.36.59-.6.92-.53.73-.56,1.28-1.22,1.46s-.71-.94-1.44-1a1.13,1.13,0,0,0-.75.33,1.86,1.86,0,0,0,.11-.91c-.16-.72-2.57-1.14-3.82-1.45s-.74.63-1.27,1.79a38.73,38.73,0,0,1-4.55,6.15,34.79,34.79,0,0,1-3.26,2.33c-1.58,1-1.49,1.46-1.95,1.71s-.63,1.28-.43,1.9,3.59,2.33,7.34,1.73a8.3,8.3,0,0,0,6.33-3.95,10.18,10.18,0,0,1,4.09-3.21,8.52,8.52,0,0,0,2.7-1.62A5,5,0,0,0,374.92,388.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.93,392.09a38.73,38.73,0,0,0,4.55-6.15c.53-1.16,0-2.09,1.27-1.79s3.66.73,3.82,1.45-.55,2.34-2.05,4.29a22.27,22.27,0,0,1-4.3,3.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,396.79c.66.21,1.38.43,1.39.68a5.43,5.43,0,0,0,.28,2.14,1.76,1.76,0,0,0,1.4.73,17.64,17.64,0,0,0,5-.11,9.23,9.23,0,0,0,4.68-2.62c1.51-1.52,1.82-2.27,3.76-3.39a37,37,0,0,0,3.51-2,4.5,4.5,0,0,1,.11.59,2.39,2.39,0,0,1-.89.64,23.08,23.08,0,0,0-3.59,1.8,24.47,24.47,0,0,0-2.71,2.69,9.54,9.54,0,0,1-4.88,2.63,13.71,13.71,0,0,1-6.86-.49c-1.85-.77-1.92-1.16-2.07-1.39a4.17,4.17,0,0,1,0-1.86C354.23,396.59,354.48,396.64,355,396.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.85,393.23a6.83,6.83,0,0,0-3.59-1.49,1.09,1.09,0,0,0-.53.51,8.52,8.52,0,0,1,3.49,1.51S363.78,393.73,363.85,393.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.37,390.4a10.77,10.77,0,0,1,4.22,1.67.69.69,0,0,0,.58-.52s-2.5-1.72-4.36-1.71C361.81,389.84,361.36,390.05,361.37,390.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.8,388.53c.84-.25,3.78,1.19,4.44,1.87a.58.58,0,0,0,.59-.59s-2.45-1.95-4.52-2C363.31,387.82,362.72,388,362.8,388.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,386.75c.41-.05,3.36.35,4.65,1.65a.72.72,0,0,0,.48-.63,7.91,7.91,0,0,0-4.74-1.7A1.1,1.1,0,0,0,364,386.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.28,324c1.09,3.52,4,10.16,1.77,18.21-2.14,7.84-6.76,19.76-7.78,23.9.15-2.6-2.15-4.53-6.82-5.54s-9.25.72-9.47,2.18l2.3-14.56-9.21,8.92a11.25,11.25,0,0,0-6.37-6.59c-3.79-1.51-6.13-.84-6.93-.15,0,0,11.48-18.4,12.47-20.88a10.32,10.32,0,0,0,.34-6.26Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.28,348.18l.93-8.45s-5.91-2.56-8.85-7.3c.74,3.71,4.91,7.26,6.57,8.2l-.14,7.39-7.72,9.08Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.82,324.16c2.29-5,4.82-11.6,4.82-11.6s-2.85-11.9-2.67-17.62c.06-2,2.6-6.55,6.76-4.51.7.83,2.83,13.11,4.32,18.93.79,3.07,1.14,4.6-.2,7-2.17,4-6.7,9.23-6.42,12.05",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.24,317.79c-4.38-9.63-5.45-10.69-5.59-15.8a15.56,15.56,0,0,1,2.39-8c1.12-1.62,3-3.68,4-3.61,1.37.1,4.4-.3,6.55.19,6.32,1.45,10.84,2.83,10.84,2.83,2.9,2.58,5.29,5.55,7.43,11.53s7.28,19.92,8.68,27.15c-12.5,6.83-28.3,1.77-32-4.73C372.12,324.55,372.32,322.38,370.24,317.79Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.92,288.87c.34-2,4.42-4.83,5.37-8.29,1.24-4.52-.45-9.28-3.63-9.6-.34-3.1-5.26-5-8.36-4.47-2.68.31-6.37,1-8.34-1.29a3.78,3.78,0,0,0,.54,3.86,14,14,0,0,0-2.6-.67c-.46,1.62.7,3.14,1.29,4.53a5.15,5.15,0,0,0,2.49,7.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.36,293.92h0c-.35-1.67-.63-3.49-.63-3.49l8.92-6.13,1,7.62a.52.52,0,0,1,0,.22c.11,1.92-2,4.42-5.13,7.65a32.32,32.32,0,0,0-4.12,5.1,21.69,21.69,0,0,1-.44-7A13.45,13.45,0,0,0,371.36,293.92Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,284.54s-.16,3.09-2,4.76c-.36.33-1.7,1.72-6.11,2.31l-.19-1.18a17.06,17.06,0,0,0,3.35-.52,10.77,10.77,0,0,0,2-.88C378,288,378.66,285.1,379,284.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.37,271.55c-.09.12.47.64.55.71a6.18,6.18,0,0,0,1.12.86,8.79,8.79,0,0,0,2.6,1.06,17.07,17.07,0,0,0,4.57.34.3.3,0,0,1,.21,0,.41.41,0,0,1,.13.22,5,5,0,0,0,.47,1.38,3.36,3.36,0,0,0,1.46,1.1.32.32,0,0,1,.13.1.22.22,0,0,1,0,.14c0,1.14-.67,2.27-.39,3.37a1,1,0,0,0,.31.56.59.59,0,0,0,.88-.1c.52-.59.82-1.34,1.28-2,.18-.25.38-.48.58-.71a3,3,0,0,1,.86-.73,2.06,2.06,0,0,1,1.65.07,2.42,2.42,0,0,1,1.31,1.86,5.11,5.11,0,0,1-1.07,3.84,2.59,2.59,0,0,1-1.93,1.2c-1.17.08-1.47-.55-1.47-.57h0l-.69.52a9.09,9.09,0,0,1-2.26,3.94,7.34,7.34,0,0,1-4.23,1.56,16.29,16.29,0,0,1-6.61-.71c-1.09-.53-2.82-1.65-2.2-8.45C364.41,272.93,366.16,271.84,366.37,271.55Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.77,279.54a.87.87,0,1,0,1-.78A.9.9,0,0,0,371.77,279.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.19,285.17a.68.68,0,1,0,.76-.61A.69.69,0,0,0,369.19,285.17Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.14,277l2.11.06a1.11,1.11,0,0,0-1.06-1.11A1,1,0,0,0,372.14,277Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.48,275.76l2,.73a1,1,0,0,0-.6-1.36A1.11,1.11,0,0,0,365.48,275.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.32,278.41a.86.86,0,1,0,1-.78A.88.88,0,0,0,365.32,278.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.59,278.83l-1.35,4.52L365.48,282a7.75,7.75,0,0,1,3.38-3.57C369.84,278.1,369.59,278.83,369.59,278.83Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--barbell--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.23,309.68h0c-2.08-6.81-10.35-10.24-15.27-8.46h0a14.88,14.88,0,0,0-3.59,1.53c-7.72,4.45-14,15.29-14,24.2a14.53,14.53,0,0,0,.63,4.43h0c1.27,4.36,7.3,10.65,15.26,8.42h0a15.41,15.41,0,0,0,3.58-1.53c7.72-4.46,14-15.3,14-24.21A14.64,14.64,0,0,0,358.23,309.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.87,338.28c7.72-4.46,14-15.3,14-24.21s-6.25-12.53-14-8.08-14,15.29-14,24.21S337.15,342.74,344.87,338.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.5,317.37c2.05-1.18,3.71-.22,3.71,2.15a8.19,8.19,0,0,1-3.71,6.42c-2.05,1.19-3.72.23-3.72-2.14A8.22,8.22,0,0,1,344.5,317.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.77,320.92a2.84,2.84,0,0,1-1.27,2.21.92.92,0,0,1-.86.11l-.09-.05a1,1,0,0,1-.32-.8,2.82,2.82,0,0,1,1.27-2.2.9.9,0,0,1,.85-.11l.09.05A.92.92,0,0,1,345.77,320.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.23,356.49a2.8,2.8,0,0,1-1.27,2.2,1,1,0,0,1-.55.17.79.79,0,0,1-.42-.12l-61.35-35.5-.09-.05a1,1,0,0,1-.32-.8,2.82,2.82,0,0,1,1.27-2.2.9.9,0,0,1,.85-.11l.09.05,61.34,35.5A.87.87,0,0,1,407.23,356.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.63,352.13h0c-2.09-6.81-10.36-10.23-15.27-8.45h0a15,15,0,0,0-3.58,1.53c-7.72,4.45-14,15.29-14,24.21a14.41,14.41,0,0,0,.63,4.42h0c1.28,4.36,7.31,10.65,15.27,8.42h0a15,15,0,0,0,3.58-1.53c7.71-4.45,14-15.29,14-24.21A14.64,14.64,0,0,0,431.63,352.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.27,380.73c7.71-4.45,14-15.29,14-24.21s-6.26-12.53-14-8.07-14,15.29-14,24.21S410.55,385.19,418.27,380.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.89,359.83c2.05-1.18,3.71-.23,3.71,2.14a8.19,8.19,0,0,1-3.71,6.43c-2.05,1.18-3.71.22-3.71-2.14A8.19,8.19,0,0,1,417.89,359.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.16,363.38a2.81,2.81,0,0,1-1.26,2.2,1,1,0,0,1-.86.12l-.09-.06a.91.91,0,0,1-.33-.79,2.82,2.82,0,0,1,1.28-2.21.88.88,0,0,1,.84-.11l.1.06A.92.92,0,0,1,419.16,363.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.24,365.15a2.8,2.8,0,0,1-1.27,2.2,1,1,0,0,1-.55.17.85.85,0,0,1-.43-.12L417,365.7l-.09-.06a.91.91,0,0,1-.33-.79,2.82,2.82,0,0,1,1.28-2.21.88.88,0,0,1,.84-.11l.1.06,3,1.7A.89.89,0,0,1,422.24,365.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.24,365.15a2.82,2.82,0,0,1-1.27,2.2.92.92,0,0,1-.86.11l-.09,0a1,1,0,0,1-.32-.8,2.83,2.83,0,0,1,1.27-2.2.9.9,0,0,1,.85-.11l.09.05A.94.94,0,0,1,422.24,365.15Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.4,293.36c2.14.64,4.45-.06,7,1.88,3,2.31,3.79,4.67,3.81,8.43,0,2.94,1.67,10.61,2.56,15.58.56,3.11.84,3.27,0,7.54-.68,3.35-5,15.36-4.74,18.18a13.31,13.31,0,0,1,0,4.95l-1.6-.93s-.7.25-1.12,1.5a2.57,2.57,0,0,0,.06,2.05l1.66.95-.54.21-.49.16-.5.22a4.16,4.16,0,0,1-1,.31,2.53,2.53,0,0,1-.91,0,.42.42,0,0,1-.27-.16.83.83,0,0,0-.2-.22c-.73-.53-1.8-.13-2.52-.7-.42-.34-.59-.95-1.08-1.16s-1.11.06-1.6-.17-.63-1-.64-1.58l-.06-2.67a5.92,5.92,0,0,1,.16-1.83,3.7,3.7,0,0,1,1.09-1.6c2.7-2.44,2.91-3,3-3.58,1.11-5.21,1.93-18.47,1.93-18.47L388,306.66S385.44,297.82,388.4,293.36Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.43,328.45a13.36,13.36,0,0,1,0,5l-1.6-.93s-.71.24-1.12,1.49a2.57,2.57,0,0,0,.06,2l1.66,1-.54.2c-.16.06-.33.1-.49.17s-.33.14-.5.21a4.16,4.16,0,0,1-1,.31,2.32,2.32,0,0,1-.91,0,.42.42,0,0,1-.27-.16,1.37,1.37,0,0,0-.2-.22c-.74-.53-1.8-.13-2.52-.7-.42-.33-.59-.95-1.08-1.16s-1.11.07-1.6-.17-.63-1-.64-1.58l-.06-2.66a6,6,0,0,1,.16-1.84,3.67,3.67,0,0,1,1.09-1.6c2.7-2.44,2.91-3,3-3.58",
    style: {
      fill: "#ffa8a7"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.58,152.79l-47.15-27.22a3.47,3.47,0,0,0-3.15-.06,1,1,0,0,0-.6.9c0,.29,0,1.4,0,1.72a1.19,1.19,0,0,0,.7.92l47.15,27.23,3.05-1.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.38,127.33a1.19,1.19,0,0,1-.7-.92,1,1,0,0,1,.6-.9,3.47,3.47,0,0,1,3.15.06l47.15,27.22-3.05,1.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,248.55,363.64,151l-6.1-3.52-3.05,1.76,30.65,91.62L357.54,225l-3.05,1.76v3.52l37.07,21.4a1.09,1.09,0,0,0,1.12,0l3.05-1.76A1.11,1.11,0,0,0,396.24,248.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.24 248.55 392.84 238.59 389.5 228.61 382.81 208.65 376.25 188.65 366.86 161.05 363.64 151.03 367.04 160.99 376.48 188.57 383.17 208.53 389.74 228.53 393.02 238.53 396.24 248.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.56,251.64l-13.47-7.78-23.6-13.62v-3.52l23.89,13.79,7.1,4.1a.48.48,0,0,0,.7-.57l-3.48-10.5-28.21-84.27,6.1,3.52,26.67,79.63,5.94,17.89A1.13,1.13,0,0,1,391.56,251.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7,233.54l-11.14-33.31c-3.66-11.12-13.46-39.83-17.07-51,3.76,11.08,13.53,39.8,17.24,50.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.56,251.64l-13.47-7.78a18.5,18.5,0,0,1,.29-3.35c.61-3.3,2.15-5.68,4.32-7a8.21,8.21,0,0,1,4.56-1.12l5.94,17.89A1.13,1.13,0,0,1,391.56,251.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,234a1.73,1.73,0,0,1,.79,1.37c0,.5-.35.7-.79.45a1.74,1.74,0,0,1-.78-1.36C384.69,234,385,233.79,385.47,234Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.67,242a1.72,1.72,0,0,1,.79,1.36c0,.5-.35.71-.79.46a1.79,1.79,0,0,1-.79-1.37C378.88,241.91,379.24,241.71,379.67,242Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.27,191.5l-3-1.77a.8.8,0,0,0-.85-.06L288,191.59a1.14,1.14,0,0,0-.45,1v2.82l5.64,3.26,3.34-1.93V194A3.09,3.09,0,0,0,295.27,191.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.94,193.43l-3.06-1.77c-.71-.41-1.29,0-1.29,1v2.82l5.64,3.26V195.9A3.08,3.08,0,0,0,291.94,193.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.75,193.67l-3-1.72a.8.8,0,0,0-.81-.06h0l-40.5,23.38h0a1.1,1.1,0,0,0-.44,1v.87l5.47,3.16L293,196.93v-.87A3,3,0,0,0,291.75,193.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.87,216l-3.05-1.76a.83.83,0,0,0-.85-.07l-3.33,1.93a1.13,1.13,0,0,0-.45,1v2.83l5.65,3.26,3.33-1.93v-2.83A3.1,3.1,0,0,0,252.87,216Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.54,217.9l-3.06-1.76c-.71-.42-1.29,0-1.29,1v2.83l5.65,3.26v-2.83A3.09,3.09,0,0,0,249.54,217.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.88 217.91 342.3 268.96 342.3 271.73 253.88 220.69 253.88 217.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.88 217.91 342.3 268.96 342.3 271.73 253.88 220.69 253.88 217.91",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.01 195.33 253.88 217.91 342.3 268.96 381.43 246.38 293.01 195.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.51,199.67l69.78,40c5.39,3.1,5.4,8.12,0,11.23l-14,8.11c-5.38,3.11-14.11,3.11-19.5,0l-69.52-40.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.5 199.67 296.1 200.58 262.85 219.78 261.25 218.86 294.5 199.67",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.19,255.42a.23.23,0,0,1-.14,0L272,216.66a.29.29,0,0,1-.1-.39.28.28,0,0,1,.38-.1l67.08,38.73a.28.28,0,0,1,.1.38A.28.28,0,0,1,339.19,255.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.28,251.9a.27.27,0,0,1-.14,0l-67.07-38.72a.29.29,0,0,1-.1-.39.28.28,0,0,1,.38-.1l67.07,38.73a.27.27,0,0,1,.11.38A.29.29,0,0,1,345.28,251.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.38,248.38a.23.23,0,0,1-.14,0l-67.07-38.72a.28.28,0,0,1-.1-.39.28.28,0,0,1,.38-.1l67.07,38.73a.28.28,0,0,1,.11.38A.3.3,0,0,1,351.38,248.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.48,244.86a.23.23,0,0,1-.14,0L290.27,206.1a.29.29,0,0,1-.11-.39.29.29,0,0,1,.39-.1l67.07,38.73a.28.28,0,0,1,.1.38A.27.27,0,0,1,357.48,244.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M296.34,228.41a55,55,0,0,1,11.27,6.64c3.9,3,7.41,6.51,11.61,9a36.93,36.93,0,0,0,18.27,5c3.61.09,7.58-.4,10.08-3a4.15,4.15,0,0,0,1.25-2.43,5,5,0,0,0-1.67-3.58c-4.9-5.36-12.06-7.93-19-10s-11-4.41-17.7-8.5c-2.86-1.76-5.66-3.63-8.55-5.29l-.07,0a44.74,44.74,0,0,0-4.39-2.45,35.49,35.49,0,0,0-7.71-2.58,16.14,16.14,0,0,0-8.05.37,3.69,3.69,0,0,0-1.76,1.08,3,3,0,0,0-.53,1.66,6.14,6.14,0,0,0,1,3.42,13,13,0,0,0,2.38,2.71C286.67,223.93,291.56,226.32,296.34,228.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289,192.69a2.77,2.77,0,0,0-2.13,1.23,12.7,12.7,0,0,0-.52,3.64,10.83,10.83,0,0,1-1.7,6c-1.2,1.85-2.59,5.92-1.46,8.46s2.56,4.59,5.11,5,4.85-2.39,5.53-4.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.1,210.5a4.75,4.75,0,0,1-.19-1.41,8.5,8.5,0,0,1,.84-3.74,23.86,23.86,0,0,0,1.94-3.63,17.17,17.17,0,0,0,1-4.19,14.19,14.19,0,0,1,.47-3.5c1.23-3.31,4.86-3,6.92-3.34l7.39-5.34,2.77,9.91s-4,1.47-5.17,2.08c-1.54.82-3,2.78-3.9,4.18-1.18,1.78-2.64,3.63-2.65,5.85a17.38,17.38,0,0,0,.52,3.57,3.51,3.51,0,0,1,.11,1,3.46,3.46,0,0,1-1.71,2.16c-1.24.9-2.73,1.84-4.2,1.39a4.68,4.68,0,0,1-2-1.58A9.67,9.67,0,0,1,284.1,210.5Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.87,208.11a8.53,8.53,0,0,1,1-3.93,31.83,31.83,0,0,1,3.06-4.52c.72-.7,1.37-.91,1.14-1.14a25.5,25.5,0,0,0-5.81-1.27c-1.4,0-1.58.83-2.32,1.46a6.41,6.41,0,0,0,1.15-3.13c0-1.13.47-4.18,2.39-4.68l.61-.21s.05-.46-.75-.27a23.26,23.26,0,0,0-4.46,1.31,4,4,0,0,0-2.35,3.29c-.28,2,0,2.71-.54,4.74a18.55,18.55,0,0,1-2.19,5.16,8.67,8.67,0,0,0-.93,6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.16,153.1A102.74,102.74,0,0,1,333,176.36c-2.47,9.29-3.69,10.66-5.29,11.43-7.09,3.39-26.06,8.85-26.06,8.85s-4.06-4.08-3.12-8.64c5.6-4,14.75-10.95,19.15-10.67l-8.36-26.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.77,216.09a6.59,6.59,0,0,0,5.1-3.26c1.05-1.75,0-4,0-4.72-.14-.27-2-1-5.15-.53s-4.23,1.79-4.85,3.34C284,212.49,286.5,216.09,288.77,216.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.2,225.79c-.7.05-.56-.89-1-3s-1.95-11.31-1.95-11.31l-10.8,4.07s2.9,7.64,3.81,9.84c1,2.45,2.43,5.81,2.66,7.71s.34,7.22,2.73,8.17,4.6-.13,6.18-1.17,3.4-4.63,5.15-6.46,3.21-2.84,4.56-4.72,1.25-6.56-.58-7.53-4.41.14-5.93,1.06S342.5,225.7,341.2,225.79Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.14,150.29c-1.94,8.44-3.07,15.43.27,21.68s6,10,13.46,24.13a29.55,29.55,0,0,0,2.41,12.31c2.89,7.42,6.05,15.39,6.05,15.39a9.66,9.66,0,0,1,9.42-4c-.34-3.65-2.52-21.05-3.59-26.19-1.33-6.4-6.48-28.3-6.48-28.3a15,15,0,0,0,6-12.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.8,239.77a21.23,21.23,0,0,1-1.07-5.72,9.82,9.82,0,0,0-.76-3.64s.29-1.84,3.14-4.1,4.63-1.2,4.63-1.2.65,1.12,2.45-.94l3.34,4.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.2,221.14c-1.06-1-2.76-1-5,.12a13.19,13.19,0,0,0-4,2.91,2.93,2.93,0,0,0,.62,3.62C345.6,229.25,352.2,221.14,352.2,221.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.83,223.1a2.29,2.29,0,0,0-.86-1.53l-.77-.43c-1.32-.86-3.7,1-5.7,2.8-2.33,2.12-4.48,6.36-6.37,9.23s-4.23,4-5,5.25a2.09,2.09,0,0,0,.22,2.57c.12.13.57.55.66.63a3.41,3.41,0,0,0,3,.58,9.23,9.23,0,0,0,6.65-4.4c2.16-3.08,3.3-4.68,5.82-6.65S354.37,225.57,353.83,223.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.83,223.1c-.76-3.48-4-1.07-6.56,1.28-2.33,2.11-4.49,6.36-6.37,9.23s-4.29,3.95-5,5.25c-1.3,2.36.5,3.85,3.12,3.34a9.23,9.23,0,0,0,6.65-4.4c2.16-3.08,3.3-4.68,5.82-6.65S354.37,225.57,353.83,223.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.84,225.29h0c-.79.35-1.1-.18-1.1-.18-2.48,2.51-2.75,4.12-2.75,4.12A27.85,27.85,0,0,1,341.84,225.29Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.64,125.6c1.35-3.93,1.62-4.78,2.13-5.6a15.67,15.67,0,0,0,2.17-3.58c.4-1.39.69-2.56.69-2.56s.3-1.31-.18-1.87a.85.85,0,0,0-1.15-.25,1.19,1.19,0,0,0-.22-1.46,1.14,1.14,0,0,0-1.45,0s.53-1.17-.43-1.74a1.09,1.09,0,0,0-1.51.26,1.33,1.33,0,0,0-.77-1.68c-.64-.3-1.39-.06-2.34,2a2.9,2.9,0,0,0-1.52.75,9.41,9.41,0,0,0-1.46,4.34c.08,1,.25,2.11.43,3.32a6.36,6.36,0,0,1-.65,4.25c-.84,1.75-4.49,8.2-4.49,8.2s-1.47-1.14-7.78-5.73c-4.48-3.25-5.88-4.89-10-4.88-5.73,0-1.55,6.42,1.21,11.68,4.42,2.6,11.52,6.84,14.66,8.15,3.68,1.54,5.78,1.74,7.39-.67C359.2,134.37,360.43,129.12,361.64,125.6Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.08,115.86l-.1.08a1,1,0,0,1-.88.21.8.8,0,0,1-.33-.61,3.52,3.52,0,0,1,.13-1.11,0,0,0,0,0,0-.05s-.07,0-.1,0-.28.34-.44.5a.86.86,0,0,1-.78.29c-.6-.07-.67-.83-.6-1.32,0-.16,0-.33.07-.49s0,0,0,0h0a.8.8,0,0,0-.22.23,1.9,1.9,0,0,1-.25.24.75.75,0,0,1-.4.17c-.32,0-.43-.29-.51-.55a2.47,2.47,0,0,1-.05-1.32v0l.11,0c1.15.28,1.67-.84,1.33-1.18s-.41-.46-.61-.69a4.81,4.81,0,0,0-.82-.74,1.84,1.84,0,0,0-.94-.4,4.66,4.66,0,0,0-1.06.12,2.43,2.43,0,0,1,2.23.81l.54.54.3.3a.87.87,0,0,1,.17.21c.21.53-.6.82-1,.79a7,7,0,0,1-1.67-.5c-.09.46-1.17,1.08-1.17,1.08a9.31,9.31,0,0,1,2.33,1.83,10.4,10.4,0,0,1,1.92,3.24,6.51,6.51,0,0,0-1.2-3.12.94.94,0,0,0,.49-.14c-.07.68,0,1.34.82,1.43a1.07,1.07,0,0,0,1-.36,1,1,0,0,0,.41,1,.85.85,0,0,0,1.12-.13,1,1,0,0,0,.15-.21s0,0,0,0S365.1,115.86,365.08,115.86Zm-5.86-4.17s.26.09,1.14.31a4.18,4.18,0,0,0-.28.56.86.86,0,0,1-.21.28.18.18,0,0,1-.08,0,9.61,9.61,0,0,0-1-.83A.9.9,0,0,0,359.22,111.69Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.12,112.56h0S360.14,112.53,360.12,112.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338,133.14c.3-9.33-3.3-12.93-4.89-13.7l-5.89-1c-2,.1-11.71,1.55-14.12,2-1.54.28-5.35,2.9-5.52,8.88-.12,4,.43,8,.59,14.41.12,4.66-1,8.2-2,15,10.27,3.82,21.7,3.6,29.84-1.89-.11-1.32.86-8.71,1.11-11.88S337.94,135.66,338,133.14Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320,114.32c-.25-2.28-2.36-4.77-3.26-6.79a9.59,9.59,0,0,1-1.14-5.24c.12-1.05.87-2.44,1.68-2.7a4.91,4.91,0,0,1,4-5.91,17,17,0,0,0,2.2-.48c.87-.31,1.1-1,1.82-1.52a2.53,2.53,0,0,1,3.9.72c.84-1,1.91-.88,3.12-.5a2.11,2.11,0,0,1,1.48,2.47,2.21,2.21,0,0,1,3.23,1.4c.07.72-.11,1.32.32,2a1.1,1.1,0,0,0,1.81.23c.11,1-.33,1.77-1.42,1.65a2.35,2.35,0,0,1,.17,2,2.13,2.13,0,0,1-2,1.34,3.4,3.4,0,0,1-.58,1.51,3.55,3.55,0,0,1-1.36,1.1,22.87,22.87,0,0,1-5.38,1.11l-2.16.32c-.13,0-.77,0-.85.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,111.24a2.18,2.18,0,0,0,2.66.08l-.44,4.54-.54,3.66s3.71,5.43,9.78,6.07a6.86,6.86,0,0,0-.36-5.06l.39-3.49a21.59,21.59,0,0,0,2.69,0,4.7,4.7,0,0,0,4-3.34,20.33,20.33,0,0,0,.68-7.66,6.81,6.81,0,0,1,0-1.86,8.63,8.63,0,0,0-.32-4c-1.85-1.68-7.34-2.33-11.69,0,.78,2.19.08,4.34-1.79,5.18.05.68,0,2.39-1.08,2.3-.79-.07-.79-1.08-1.56-2s-2.67-1.28-3.48,0A4.31,4.31,0,0,0,317.4,111.24Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.89,117c-2.79-.5-4.9-.93-6.25-3.05a17.9,17.9,0,0,1-1.5-3.42,14,14,0,0,0,1,4.24c.63,1.34,2.31,2.52,6.69,3.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.84,106a.79.79,0,0,1-.85.76.81.81,0,0,1-.73-.87.79.79,0,1,1,1.58.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.18,103.64l-1.77.77a1,1,0,0,1,.52-1.31A.94.94,0,0,1,328.18,103.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.29,104.11l-1.85-.62a1,1,0,0,1,1.21-.63A1,1,0,0,1,335.29,104.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.06,105.88a.8.8,0,0,1-.85.76.82.82,0,0,1-.73-.88.8.8,0,0,1,.85-.76A.81.81,0,0,1,335.06,105.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.73,108.92,330.91,110l-.54-5.44C331.42,104.24,332.59,106.79,333.73,108.92Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.86,111.13l3.26.9a1.66,1.66,0,0,1-2.05,1.24A1.78,1.78,0,0,1,327.86,111.13Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.22,111.69a2.82,2.82,0,0,0-.41,0,1.77,1.77,0,0,0,1.26,1.6,1.65,1.65,0,0,0,.54,0A1.56,1.56,0,0,0,328.22,111.69Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.29,163.17a9.07,9.07,0,0,1-1-2.85c.11-.76,1.33,1.13,1.88,1.5a2.05,2.05,0,0,0,1.51.46c.34,0,.89-.37.84-.72,0-.08-.07-.12-.12-.17a19.94,19.94,0,0,1-1.83-2.81,10.36,10.36,0,0,0-1.7-2.26,5.76,5.76,0,0,1-1.53-3.29,92.73,92.73,0,0,1,.16-12.72c3.85-1.54,12.35-5.39,14.05-6.06A8.2,8.2,0,0,0,314,129.5c.94-2.13.54-7.82-.91-9-3.41.3-4.62,1.33-8,3.22-2.1,1.18-3.39,2-8,4.69-1.71,1-4.93,2.82-8.06,4.85a3.86,3.86,0,0,0-2.17,4.08,72.52,72.52,0,0,0,.65,7.61c.27,2,.52,2.9,1,6.17.09.63.22,1.62.37,2.79s.19,2.8.22,4a20.8,20.8,0,0,0,.39,3.62,12.13,12.13,0,0,0,1.91,4.28c.26.25.58.31.82.56s.37.58.63.81c.41.36.76.26,1.37.2a1.14,1.14,0,0,1,.71.11,3.05,3.05,0,0,1,.53.49,2.09,2.09,0,0,0,2.19.3l1.47,1.15a.51.51,0,0,0,.32.12.26.26,0,0,0,.17-.13,1.36,1.36,0,0,0,.24-1,3.58,3.58,0,0,0-.75-1.78A35.17,35.17,0,0,1,297.29,163.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M308.76,182.71l-47.15-27.22a3.47,3.47,0,0,0-3.15-.06,1,1,0,0,0-.6.9c0,.29,0,1.39,0,1.72a1.19,1.19,0,0,0,.7.92l47.15,27.22,3.05-1.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.56,157.25a1.2,1.2,0,0,1-.7-.92,1,1,0,0,1,.6-.9,3.47,3.47,0,0,1,3.15.06l47.15,27.22-3.05,1.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.74,244.3l-3.06-1.76a.83.83,0,0,0-.85-.07l-3.33,1.93a1.16,1.16,0,0,0-.45,1v2.82l5.65,3.26L388,249.6v-2.82A3.12,3.12,0,0,0,386.74,244.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.4,246.23l-3-1.76c-.72-.42-1.3,0-1.3,1v2.82l5.65,3.26V248.7A3.1,3.1,0,0,0,383.4,246.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.21,246.47l-3-1.71a.8.8,0,0,0-.82-.06h0l-40.51,23.39h0a1.09,1.09,0,0,0-.44,1V270l5.48,3.17,40.5-23.38v-.87A3,3,0,0,0,383.21,246.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34,268.78,341.28,267a.83.83,0,0,0-.85-.06l-3.33,1.92a1.17,1.17,0,0,0-.45,1.05v2.82L342.3,276l3.33-1.93v-2.82A3.1,3.1,0,0,0,344.34,268.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,270.71,338,268.94c-.72-.41-1.3,0-1.3,1v2.82L342.3,276v-2.82A3.1,3.1,0,0,0,341,270.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.42,278.47,311.81,181l-6.1-3.52-3,1.76,30.65,91.62-27.6-15.93-3,1.76v3.52l37.07,21.4a1.12,1.12,0,0,0,1.12,0l3-1.76A1.14,1.14,0,0,0,344.42,278.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.42 278.47 341.01 268.51 337.67 258.53 330.98 238.57 324.42 218.57 321.13 208.57 311.81 180.95 321.31 208.51 324.65 218.49 331.34 238.45 337.91 258.45 341.19 268.45 344.42 278.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.73,281.57l-13.47-7.79-23.6-13.62v-3.52l23.89,13.79,7.1,4.1a.48.48,0,0,0,.7-.57l-3.48-10.5-28.21-84.27,5.74,2.43,27,80.72,5.94,17.89A1.14,1.14,0,0,1,339.73,281.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.87,263.46l-11.14-33.3c-3.65-11.13-13.46-39.83-17.07-51,3.77,11.09,13.53,39.81,17.25,50.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.73,281.57l-13.47-7.79a18.5,18.5,0,0,1,.29-3.35c.61-3.3,2.15-5.68,4.32-7a8.21,8.21,0,0,1,4.56-1.12l5.94,17.89A1.14,1.14,0,0,1,339.73,281.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.65,264a1.74,1.74,0,0,1,.78,1.36c0,.5-.35.7-.78.45a1.72,1.72,0,0,1-.79-1.36C332.86,263.92,333.21,263.71,333.65,264Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.84,271.88a1.72,1.72,0,0,1,.79,1.36c0,.51-.35.71-.79.46a1.74,1.74,0,0,1-.78-1.36C327.06,271.83,327.41,271.63,327.84,271.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,153.84c-.93-2.85-5.93-5.06-14.41-6.33l-54.88,31.68,1,3.12c26-3.6,50.54-10,62.43-16.87,5.52-3.18,7.67-6.08,6.85-8.51C372.64,155.94,372.27,154.82,372,153.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,162.32c-11.89,6.87-36.44,13.27-62.44,16.87l54.88-31.68C373.25,149.87,377,155.44,365.1,162.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,151.43c7.56,1.28,9.61,3,10.05,3.49-.23.46-1.22,1.92-5.08,4.15-8,4.63-22.94,9.31-40.56,12.91Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,151.43c7.56,1.28,9.61,3,10.05,3.49-.23.46-1.22,1.92-5.08,4.15-8,4.63-22.94,9.31-40.56,12.91Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.49 151.76 331.78 170.65 333.77 171.79 366.48 152.91 364.49 151.76",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.82,108c0,.77.86,1.41,2,1.44s2-.58,2-1.34-.86-1.41-2-1.44S322.84,107.27,322.82,108Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.39,108.28c0,.77.86,1.41,1.95,1.43s2-.57,2-1.34-.86-1.41-1.95-1.43S334.41,107.51,334.39,108.28Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.19,203.82,225,176.6a3.47,3.47,0,0,0-3.15-.06,1,1,0,0,0-.6.9c0,.29,0,1.4,0,1.72a1.21,1.21,0,0,0,.7.92l47.16,27.23,3-1.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,178.36a1.21,1.21,0,0,1-.7-.92,1,1,0,0,1,.6-.9,3.47,3.47,0,0,1,3.15.06l47.15,27.22-3,1.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.86,299.58l-32.61-97.52-6.1-3.52-3,1.76,30.65,91.62L269.16,276l-3.05,1.76v3.52l37.07,21.4a1.08,1.08,0,0,0,1.11,0c.44-.24,2.73-1.57,3.06-1.76A1.12,1.12,0,0,0,307.86,299.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.86 299.58 304.46 289.62 301.11 279.64 294.43 259.68 287.86 239.68 278.48 212.08 275.25 202.06 278.65 212.02 288.1 239.6 294.78 259.56 301.35 279.56 304.63 289.56 307.86 299.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.17,302.67l-13.47-7.78-23.6-13.62v-3.52L290,291.54l7.1,4.1a.48.48,0,0,0,.7-.57l-3.48-10.5-28.2-84.27,6.09,3.52,26.67,79.63,5.94,17.89A1.13,1.13,0,0,1,303.17,302.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.31,284.57l-11.14-33.31c-3.65-11.12-13.46-39.82-17.06-51,3.76,11.08,13.52,39.8,17.24,50.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.17,302.67l-13.47-7.78a18.5,18.5,0,0,1,.29-3.35c.61-3.3,2.15-5.68,4.32-7a8.23,8.23,0,0,1,4.56-1.12l5.94,17.89A1.13,1.13,0,0,1,303.17,302.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.09,285.07a1.74,1.74,0,0,1,.78,1.37c0,.5-.35.7-.78.45a1.72,1.72,0,0,1-.79-1.36C296.3,285,296.65,284.82,297.09,285.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.28,293a1.72,1.72,0,0,1,.79,1.36c0,.5-.35.71-.79.46a1.77,1.77,0,0,1-.78-1.37C290.5,292.94,290.85,292.74,291.28,293Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89,242.53l-3.06-1.77a.83.83,0,0,0-.85-.06l-3.33,1.92a1.17,1.17,0,0,0-.45,1v2.82l5.65,3.26,3.33-1.93V245A3.1,3.1,0,0,0,206.89,242.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.55,244.46l-3.05-1.77c-.72-.41-1.3,0-1.3,1v2.82l5.65,3.26v-2.82A3.09,3.09,0,0,0,203.55,244.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.36,244.7l-3-1.72a.82.82,0,0,0-.82-.06h0L159.07,266.3h0a1.11,1.11,0,0,0-.44,1v.87l5.47,3.16L204.62,248v-.87A3,3,0,0,0,203.36,244.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,267l-3.06-1.76a.83.83,0,0,0-.85-.07l-3.33,1.93a1.15,1.15,0,0,0-.45,1V271l5.65,3.26,3.33-1.93v-2.82A3.12,3.12,0,0,0,164.49,267Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.15,268.93l-3.05-1.76c-.72-.42-1.3,0-1.3,1V271l5.65,3.26V271.4A3.09,3.09,0,0,0,161.15,268.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.5 268.94 253.91 319.99 253.91 322.76 165.49 271.71 165.5 268.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.5 268.94 253.91 319.99 253.91 322.76 165.49 271.71 165.5 268.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.62 246.36 165.5 268.94 253.91 319.99 293.04 297.41 204.62 246.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,250.7l69.78,40c5.4,3.09,5.4,8.11,0,11.22l-14,8.11c-5.38,3.11-14.11,3.11-19.5,0l-69.51-40.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.12 250.7 207.72 251.61 174.46 270.81 172.87 269.89 206.12 250.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,306.45a.23.23,0,0,1-.14,0l-67.07-38.72a.28.28,0,0,1-.11-.38.29.29,0,0,1,.39-.11l67.07,38.73a.28.28,0,0,1,.1.38A.27.27,0,0,1,250.8,306.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9,302.93a.23.23,0,0,1-.14,0l-67.08-38.72a.28.28,0,1,1,.29-.49L257,302.41a.28.28,0,0,1,.1.38A.28.28,0,0,1,256.9,302.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,299.41a.27.27,0,0,1-.14,0l-67.07-38.72a.29.29,0,0,1-.1-.39.28.28,0,0,1,.38-.1l67.08,38.73a.28.28,0,0,1,.1.38A.29.29,0,0,1,263,299.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.09,295.89a.25.25,0,0,1-.14,0l-67.07-38.72a.28.28,0,1,1,.28-.49l67.07,38.72a.29.29,0,0,1,.11.39A.3.3,0,0,1,269.09,295.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M208,279.44a55,55,0,0,1,11.27,6.64c3.9,3,7.41,6.51,11.61,9.05a37,37,0,0,0,18.27,5c3.62.08,7.59-.41,10.08-3a4.15,4.15,0,0,0,1.25-2.43,5,5,0,0,0-1.67-3.58c-4.89-5.36-12.06-7.93-19-10s-11-4.41-17.7-8.5c-2.86-1.76-5.66-3.63-8.54-5.29l-.07,0a45.93,45.93,0,0,0-4.39-2.45,35.85,35.85,0,0,0-7.71-2.58,16.14,16.14,0,0,0-8,.37,3.67,3.67,0,0,0-1.77,1.08,2.87,2.87,0,0,0-.52,1.66,6,6,0,0,0,1,3.42,13.35,13.35,0,0,0,2.38,2.71C198.28,275,203.17,277.35,208,279.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.47,201.76l-17,1s-1.29,5.54-1.78,9.74,1.92,8.35,1.92,8.35l1.06,7.17c-8,2.25-11.13,6.91-15,11.3-2.83,3.19-4.64,5.24-7.06,6.58s-3.37,2,.31,5.16a4.51,4.51,0,0,0,3.86,1.2s14.22-7.92,21.82-12h0c5.74-2.73,6.65-2.86,8.53-8.34C243,220.55,243.06,206,242.47,201.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.47,201.76l-17.54,1s-1.69,7.91-1.78,11.27a13.19,13.19,0,0,0,2.07,6.61l.51,2.2c3.31,1.26,14.5.11,16.28-2.28C242.79,215.63,243.1,205.72,242.47,201.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.5,260.38a15.56,15.56,0,0,1,2.72-6c1.43-1.92,2.76-2.47,2.06-3l-.31.17c-1.82.19-3.65-1.34-4.4-1.59s-2.19,2.68-3,5a15.71,15.71,0,0,0-.88,5.83Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5,260.38a15.56,15.56,0,0,1,2.72-6c1.43-1.92,2.76-2.47,2.06-3l-.31.17c-1.82.19-3.65-1.34-4.4-1.59s-2.19,2.68-3,5a15.71,15.71,0,0,0-.88,5.83Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M202.69,269.46c-.4.35-.94.42-2.89-.81-1.72-1.1-2.85-3.65-3.63-6a10.6,10.6,0,0,1,.65-7,14.26,14.26,0,0,0,.91-5.75c-.08-1.26-.15-1.41.34-1.75s.94-.63.94-.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.4,245.36a2.58,2.58,0,0,0-1.14,2.21,3.33,3.33,0,0,0,.47,2.11c.39.62-1,2.6-1.91,5.15-.61,1.77-1.16,5-.93,5.37a6.13,6.13,0,0,1,3.63,0,35.79,35.79,0,0,0-.12,5.05c.13,1.91.49,2.28-.14,3a4.3,4.3,0,0,1-2.75,1.13c-.67-.1-3.14-1.49-4.75-5-1.5-3.27-.61-5.51.16-8.32a16.28,16.28,0,0,0,.74-5c-.08-1.57-.19-2.67.35-3.56a5.31,5.31,0,0,1,2.16-1.42c1.44-.54,2.62-.8,3.73-1.34a1.56,1.56,0,0,1,1.33,0A3.89,3.89,0,0,1,205.4,245.36Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,267.59a2.78,2.78,0,0,0-1.67,1.17c-.11.24-.13.89-1,.7a7.61,7.61,0,0,1-3.14-2.24,18,18,0,0,1-2.32-4.53,9.05,9.05,0,0,1,.11-5.51,17.52,17.52,0,0,0,1.34-5.3c.19-2.29-.13-2.91,0-3.39a3,3,0,0,0-.42.38c-.17.84.29,1.44-.19,4.51a26.58,26.58,0,0,1-1.17,3.83,9.88,9.88,0,0,0-.07,5.76,11.18,11.18,0,0,0,4.32,6.35,3.85,3.85,0,0,0,4.65-.14,2.28,2.28,0,0,0,.71-1.51C205.61,267.23,205.07,267.33,204.38,267.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.62,260.64c1.45-.7,3.79-.21,3.84.26l0,.23s.18,0,.25-.61c-.05-.45-.31-.77-1.58-.93a5.56,5.56,0,0,0-2.51.24S201.36,260.47,201.62,260.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,258.1c2.14-.51,3.89.3,4,.62l0,.15s.25,0,.32-.61c0-.24-.4-.74-1.56-1a6,6,0,0,0-2.61.09S201.73,257.86,202,258.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.38,256c2.61-.8,4.31.5,4.36.82l-.07.15s.25,0,.38-.58c0-.25-.33-.77-1.46-1.11a5.47,5.47,0,0,0-3.06,0S202.18,255.74,202.38,256Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.11,253.55c2.38-.42,4.71,1,4.77,1.34l-.08.12s.26.08.39-.55c0-.25-.41-.58-1.47-1.11a5.59,5.59,0,0,0-3.35-.5S202.91,253.29,203.11,253.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.8,289.11c-.52-.14-1-.29-1.52-.46-4.7-1.58-10-4.58-11.45-9.41a3.6,3.6,0,0,1,.94-3.67,3.54,3.54,0,0,0,1-3.23c-.82-4.1-3.07-13.71-2.45-20.69l-1.44-.91-1.8,1-.07.8c-.64,7.22,1.15,17.38,1.95,21.41a2,2,0,0,1-.54,1.81,5.11,5.11,0,0,0-1.43,5,17.19,17.19,0,0,0,10.8,11.52c.52.17,1.07.34,1.62.48a3.88,3.88,0,0,0,.79.1,6.45,6.45,0,0,0,3-.77,2,2,0,0,0,1.07-1.71l0-.85h0C255.32,289.35,255.15,289.2,254.8,289.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.32,289.55h0c0,.28-.34.64-1,1a6.08,6.08,0,0,1-3.57.78c-.51-.14-1-.29-1.52-.45a15.68,15.68,0,0,1-9.79-10.34,3.6,3.6,0,0,1,.94-3.66,3.53,3.53,0,0,0,1-3.24c-.81-4.09-2.54-14-1.92-21l1.85-1c-.62,7,1.63,16.59,2.45,20.69a3.54,3.54,0,0,1-1,3.23,3.6,3.6,0,0,0-.94,3.67c1.49,4.83,6.75,7.83,11.45,9.41.49.17,1,.32,1.52.46C255.15,289.2,255.32,289.35,255.32,289.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,276.63a3.53,3.53,0,0,1,.75-1.06,3.5,3.5,0,0,0,1.06-2.25l-2.37,1.32a3.55,3.55,0,0,1-1.06,2.25,3.41,3.41,0,0,0-.75,1.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.59,202.58a71.37,71.37,0,0,0-3.53,6.65,12.46,12.46,0,0,0,1,11.85,78.15,78.15,0,0,0,7.36,10.3c3.48,3.7,8.79,9.19,9.9,10.27s2.73,2.82,2.73,2.82a50.64,50.64,0,0,0-.08,5.81c.71,1.18,2.72,2.14,5.88,2.53a10.43,10.43,0,0,0,5.64-1.16,60.32,60.32,0,0,0-.51-10.76c-.47-4.28-8.14-16.88-13.06-26.18a14.17,14.17,0,0,0,4.88-5.34,48.07,48.07,0,0,0,2.64-7.61Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.86,227.33a2.07,2.07,0,0,0,1.27-.14l-2.08-3.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,242.25c.23-1.56,3.22-4.94,6.54-6.07s4.39-.88,5-.57.92,1.5,1.42,2.59a10.52,10.52,0,0,1,1.11,5.57c-.08,3.17,0,8,0,8s-6.42,3.92-12.13-1.31a51.29,51.29,0,0,1-.18-6C235.71,243.34,234.84,243.05,235,242.25Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,242.25c.23-1.56,3.22-4.94,6.54-6.07s4.39-.88,5-.57.92,1.5,1.42,2.59a10.52,10.52,0,0,1,1.11,5.57c-.08,3.17,0,8,0,8s-6.42,3.92-12.13-1.31a51.29,51.29,0,0,1-.18-6C235.71,243.34,234.84,243.05,235,242.25Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.3,241.32c-1.27.44-1.59,1.64-2.09,1.7s-1.21-.86-1-1.45a2.42,2.42,0,0,0-.22.68c-.12.8.75,1.09,1.79,2.21A5.21,5.21,0,0,1,238.3,241.32Z",
    style: {
      fill: "#00FF00",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.82,248.88l0,.55c.65,1.23,2.87,2.07,4,1.43,1.64-.93.95-3,2-5.38,1-2.2,2.14-3,3.66-3.12,3.36-.32,2.67,4.58,2.78,11.44,0,2.36.08,3.85-.07,6.36-.07,1.22-1.16,3.16-2.48,3.53-1.93.55-3.87-.47-4.41-3.23-1.31-6.76-3.2-6.15-5.1-6.17C236.47,252,236.34,249,236.82,248.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.69,247.51c-1.84.34-2.2,2.58-2.12,5.67.06,2.61,0,5.63,2.24,5.43,1.94-.19,1.77-2.35,1.7-6.37S248.12,247.24,246.69,247.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.26,250.79a9,9,0,0,0,4.42-.78s.3.17.07.91c-.82.79-3,1.07-4.39.88C244,251.43,244.26,250.79,244.26,250.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.32,253.24a9.12,9.12,0,0,0,4.42-.79s.29.17.07.91c-.82.79-3,1.07-4.4.88A1.07,1.07,0,0,1,244.32,253.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.38,255.68a8.94,8.94,0,0,0,4.41-.79s.3.18.07.92c-.81.79-3,1.07-4.39.88C244.13,256.32,244.38,255.68,244.38,255.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.05,200.66a18.46,18.46,0,0,0-3.76,7.2,21.52,21.52,0,0,0,.2,11.16,25.74,25.74,0,0,0,4.37,8.31,16.82,16.82,0,0,1,3-3.43,12.28,12.28,0,0,1-2.38-6.5,19.82,19.82,0,0,0,4.09,5,20.8,20.8,0,0,1,8.34-3.06c3.57-.39,5,.92,5,.92l-2.75-5.52s6.48-3.29,7.26-13Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.94,175.38c1.36-3.93,1.63-4.78,2.13-5.59a15.4,15.4,0,0,0,2.18-3.59c.4-1.39.68-2.55.68-2.55s.3-1.31-.18-1.88a.86.86,0,0,0-1.15-.25,1.2,1.2,0,0,0-.21-1.46,1.14,1.14,0,0,0-1.45.05s.52-1.18-.44-1.74a1.07,1.07,0,0,0-1.5.25,1.32,1.32,0,0,0-.77-1.67c-.64-.3-1.4-.07-2.35,2a2.85,2.85,0,0,0-1.51.75,9.3,9.3,0,0,0-1.46,4.34c.07,1,.24,2.11.42,3.32a6.32,6.32,0,0,1-.64,4.25c-.84,1.75-4.49,8.21-4.49,8.21s-1.47-1.15-7.78-5.73c-4.49-3.26-5.89-4.9-10-4.89-5.73,0-1.56,6.42,1.21,11.68,4.42,2.6,11.52,6.84,14.66,8.15,3.67,1.54,5.78,1.75,7.39-.67C265.51,184.15,266.73,178.9,267.94,175.38Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.39,165.64l-.11.08a1,1,0,0,1-.87.21.77.77,0,0,1-.33-.61,3.52,3.52,0,0,1,.13-1.11v-.05s-.07,0-.1,0-.29.34-.44.5a.87.87,0,0,1-.79.29c-.6-.07-.67-.83-.6-1.32,0-.16.06-.32.07-.49,0,0,0,0,0,0h0a.84.84,0,0,0-.23.23,1.36,1.36,0,0,1-.24.24.79.79,0,0,1-.4.17c-.33,0-.43-.29-.51-.55a2.57,2.57,0,0,1-.06-1.32s0,0,0,0l.11,0c1.15.28,1.67-.84,1.33-1.17s-.41-.47-.61-.7a4.81,4.81,0,0,0-.82-.74,1.87,1.87,0,0,0-.95-.4,4.79,4.79,0,0,0-1.06.12,2.8,2.8,0,0,1,1.22.11,2.74,2.74,0,0,1,1,.7l.55.54.3.3a.65.65,0,0,1,.16.21c.22.53-.59.82-1,.8a7.35,7.35,0,0,1-1.66-.51c-.1.46-1.17,1.08-1.17,1.08a9.17,9.17,0,0,1,2.32,1.83,10.54,10.54,0,0,1,1.93,3.24,6.52,6.52,0,0,0-1.21-3.12.89.89,0,0,0,.5-.14c-.07.69,0,1.34.81,1.43a1.06,1.06,0,0,0,1-.36.93.93,0,0,0,.42,1,.85.85,0,0,0,1.12-.13,1.53,1.53,0,0,0,.14-.21l0,0S271.41,165.64,271.39,165.64Zm-5.87-4.17s.27.1,1.15.31a6.1,6.1,0,0,0-.29.57,1.1,1.1,0,0,1-.2.28l-.09.05a8.24,8.24,0,0,0-1-.83A1,1,0,0,0,265.52,161.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.42,162.34Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.53,192c.22,1.27.72,2.7.18,4.28a15.9,15.9,0,0,1-2.66,4.36c3,3.15,9.87,4.63,14.87,4.3,6.86-.45,8.55-3.2,8.55-3.2l.09-8.28Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.52,180.9c-2.28-5.9-8.08-11.68-8.08-11.68a47.64,47.64,0,0,0-9.23.07c-2.5.28-4.74.57-6.92.86a9.27,9.27,0,0,0-3.77,4.72,18.88,18.88,0,0,0-.43,7c.85,3.61,2.58,11.17,2.58,11.17,4.85,3.93,17.7,3.72,20.89,1.17,0,0,.18-2.19.31-4.16A7.39,7.39,0,0,0,247.52,180.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.42,189.49a8.14,8.14,0,0,1-7.15.54,5.89,5.89,0,0,1-3.93-6.34s-1.7,5.3,3,7.32C236.22,193.54,238.42,189.49,238.42,189.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.13,149.82a3.51,3.51,0,0,0-1.45-4.19,3.06,3.06,0,0,0-2.56-.17,2.21,2.21,0,0,0-1.51-1.09,4.19,4.19,0,0,0-3,.69,3.29,3.29,0,0,0-1.44,1.86,2.34,2.34,0,0,0,.54,2.24,1.43,1.43,0,0,0-1,1.31,1.41,1.41,0,0,0,.93,1.34,1.81,1.81,0,0,0,0,1.72,1.84,1.84,0,0,0,1.44.94,2.71,2.71,0,0,0-1.27,3.38,3.1,3.1,0,0,0,2.68,2.14,4.26,4.26,0,0,1-1.58-1.3,2.41,2.41,0,0,1-.4-2,1.67,1.67,0,0,1,1.47-1.24,1,1,0,0,0-.4,1,1.37,1.37,0,0,0,.76,1c.51.17.85.18,1.81-.29.24-.12.15.05.42,0a1.43,1.43,0,0,0,1-.63,4.55,4.55,0,0,0,.5-1.07,18,18,0,0,1,1.81-3.49A11.52,11.52,0,0,0,229.13,149.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.48,153.65a14.67,14.67,0,0,1-1.07,4.73c-.25.54-13.29,6.2-15.65,7.36a50.29,50.29,0,0,0-3.46-6.08c-2.32-3.15-2.75-8.12,1.11-10.14a7.35,7.35,0,0,1,4.53-5.48C237.62,141.64,246.24,144.64,245.48,153.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.93,149.75s2.34,3.5,1.2,10.67c-.74,4.63-1.6,6.33-3.92,7a11.43,11.43,0,0,1-4.49,0l-.4,3.08s4.61,5.26.35,5.51a9.33,9.33,0,0,1-6.32-2.43,8.69,8.69,0,0,1-2.31-3.49l.55-7.46a2.17,2.17,0,0,1-2.94-.56c-1.61-1.8-1.35-4.46.1-5.31a2.51,2.51,0,0,1,3.82,1.41c.4,1,1.87.89,1.73-1.36s.49-6.2,2.48-6.74C236.24,149.45,238.93,154.78,243.93,149.75Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.45,159.22a1.05,1.05,0,0,1-.43.88,1,1,0,0,1-.52.21c-.11,0-.07.19.05.71l.08.34a.34.34,0,0,1-.22.42h0a.34.34,0,0,1-.43-.22l-.6-1.93a1.13,1.13,0,0,1,.68-1.41A1.08,1.08,0,0,1,228.45,159.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.34,159.38c0,.77.85,1.41,1.95,1.44s2-.58,2-1.34-.86-1.41-1.95-1.44S231.35,158.62,231.34,159.38Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.9,159.63c0,.77.86,1.41,2,1.43s2-.57,2-1.34-.86-1.41-2-1.43S242.92,158.86,242.9,159.63Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.64,161.71l2.76.85a1.41,1.41,0,0,1-1.78,1A1.51,1.51,0,0,1,236.64,161.71Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.75,154.57l-2,.83a1,1,0,0,1,.56-1.42A1.15,1.15,0,0,1,236.75,154.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.32,154.54l1.85,1.16a1,1,0,0,0-.3-1.49A1.15,1.15,0,0,0,242.32,154.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.32 155.7 239.32 160.65 242.22 159.9 239.32 155.7",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.72,167.46a17.92,17.92,0,0,1-5.63-2.39,5.67,5.67,0,0,1-1.57-2.43,5.38,5.38,0,0,0,1.24,3.3c1.84,1.67,5.79,2.87,5.79,2.87Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.68,156.9a.85.85,0,0,0,.73.94.8.8,0,0,0,.93-.69.87.87,0,0,0-.73-1A.81.81,0,0,0,241.68,156.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.54,156.9a.85.85,0,0,0,.73.94.8.8,0,0,0,.93-.69.87.87,0,0,0-.73-1A.82.82,0,0,0,235.54,156.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.64,162.51H237a2,2,0,0,1,1.48,1,1.42,1.42,0,0,1-.84,0A1.44,1.44,0,0,1,236.64,162.51Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.45,212.87a9.12,9.12,0,0,1-1-2.84c.11-.76,1.34,1.13,1.88,1.5a2.14,2.14,0,0,0,1.51.46c.34,0,.89-.38.84-.73,0-.07-.07-.11-.11-.17a18.64,18.64,0,0,1-1.84-2.81A10.6,10.6,0,0,0,207,206a5.76,5.76,0,0,1-1.53-3.29,92.75,92.75,0,0,1,.16-12.72c3.85-1.53,12.35-5.39,14-6.06a8.25,8.25,0,0,0,4.5-4.75c.93-2.13.53-7.81-.91-9-3.42.3-4.63,1.33-8,3.22-2.1,1.18-3.39,1.95-8,4.7-1.71,1-4.93,2.82-8.05,4.84a3.86,3.86,0,0,0-2.18,4.08,72.48,72.48,0,0,0,.65,7.62c.27,2,.52,2.89,1,6.16.09.63.22,1.62.37,2.79s.19,2.8.22,4a20.8,20.8,0,0,0,.39,3.62,12.13,12.13,0,0,0,1.91,4.28c.26.25.58.31.82.56s.37.58.64.82.75.25,1.37.19a1.2,1.2,0,0,1,.7.11,4.1,4.1,0,0,1,.53.49,2.05,2.05,0,0,0,2.19.3l1.47,1.15a.43.43,0,0,0,.32.12.24.24,0,0,0,.17-.13,1.37,1.37,0,0,0,.25-1,3.7,3.7,0,0,0-.76-1.77C208.86,215.61,207.76,213.57,207.45,212.87Z",
    style: {
      fill: "#ffa8a7"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M220.37,233.74l-47.15-27.22a3.47,3.47,0,0,0-3.15-.06,1,1,0,0,0-.6.9c0,.29,0,1.39,0,1.72a1.21,1.21,0,0,0,.7.92l47.16,27.22,3-1.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.17,208.28a1.23,1.23,0,0,1-.7-.92,1,1,0,0,1,.6-.9,3.47,3.47,0,0,1,3.15.06l47.15,27.22-3,1.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.35,295.33l-3.06-1.76a.83.83,0,0,0-.85-.07l-3.33,1.93a1.15,1.15,0,0,0-.44,1.05v2.82l5.64,3.26,3.33-1.93v-2.82A3.12,3.12,0,0,0,298.35,295.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,297.26,292,295.5c-.72-.42-1.29,0-1.29,1v2.82l5.64,3.26v-2.83A3.12,3.12,0,0,0,295,297.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.83,297.5l-3-1.71a.78.78,0,0,0-.81-.06h0l-40.5,23.39h0a1.09,1.09,0,0,0-.44,1V321l5.48,3.16,40.5-23.38v-.87A3,3,0,0,0,294.83,297.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,319.81,252.89,318A.83.83,0,0,0,252,318l-3.33,1.92a1.16,1.16,0,0,0-.44,1.05v2.82l5.64,3.26,3.33-1.93v-2.82A3.1,3.1,0,0,0,256,319.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.62,321.74,249.56,320c-.71-.41-1.29,0-1.29,1v2.82l5.64,3.26v-2.82A3.1,3.1,0,0,0,252.62,321.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,329.5,223.42,232l-6.1-3.52-3,1.76,30.64,91.62-27.59-15.93-3.05,1.76v3.52l37.07,21.4a1.1,1.1,0,0,0,1.11,0l3.06-1.76A1.13,1.13,0,0,0,256,329.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.03 329.5 252.63 319.54 249.28 309.56 242.6 289.6 236.03 269.6 232.75 259.6 223.42 231.98 232.92 259.54 236.27 269.52 242.95 289.48 249.52 309.48 252.8 319.48 256.03 329.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.35,332.6l-13.48-7.79-23.59-13.62v-3.52l23.89,13.79,7.1,4.1A.48.48,0,0,0,246,325l-3.48-10.5-28.2-84.27,5.73,2.43,27,80.72L253,331.26A1.13,1.13,0,0,1,251.35,332.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.48,314.49l-11.14-33.3c-3.65-11.13-13.46-39.83-17.06-51C218,241.31,227.8,270,231.52,281.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.35,332.6l-13.48-7.79a17.61,17.61,0,0,1,.3-3.35c.6-3.3,2.14-5.68,4.31-7a8.24,8.24,0,0,1,4.57-1.12L253,331.26A1.13,1.13,0,0,1,251.35,332.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.26,315a1.75,1.75,0,0,1,.79,1.36c0,.5-.36.7-.79.45a1.72,1.72,0,0,1-.79-1.36C244.47,315,244.82,314.74,245.26,315Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.46,322.91a1.74,1.74,0,0,1,.78,1.36c0,.51-.35.71-.78.46a1.72,1.72,0,0,1-.79-1.36C238.67,322.86,239,322.66,239.46,322.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.57,204.87c-.94-2.85-5.94-5.05-14.42-6.33l-54.87,31.68,1,3.12c26-3.6,50.54-10,62.44-16.87,5.51-3.18,7.66-6.08,6.84-8.51C284.25,207,283.89,205.85,283.57,204.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.71,213.35c-11.89,6.87-36.43,13.27-62.43,16.87l54.87-31.68C284.86,200.9,288.65,206.47,276.71,213.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.87,202.46c7.57,1.28,9.61,3,10.05,3.49-.23.46-1.22,1.92-5.08,4.15-8,4.63-22.94,9.31-40.56,12.91Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.87,202.46c7.57,1.28,9.61,3,10.05,3.49-.23.46-1.22,1.92-5.08,4.15-8,4.63-22.94,9.31-40.56,12.91Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.1 202.79 243.39 221.68 245.38 222.82 278.09 203.94 276.1 202.79",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leg--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.84,267.5c-1.09,5.2-.82,6.9-.1,10.16.38,1.7,2.11,6.52,3.33,12,1.08,4.86,1.67,7.94,2.54,12.81a40.81,40.81,0,0,1,.76,6.76c.08,2.39.32,5.63.86,12.44a103.57,103.57,0,0,0,1.49,11.48S155,334.6,154.1,335s-1.76,1.72-2.69,1.31-3.89-3.61-3.14-6.78a24,24,0,0,0-1-4.2c-1.47-4.47-5.33-11.57-3.43-17.18,0,0-7.24-12.6-8.4-15.06s-5-8.72-4.91-13.8S146.84,267.5,146.84,267.5Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.17,342.66c.1.46.08.78-1.6,1.49a12.4,12.4,0,0,1-6.45.45,9.39,9.39,0,0,1-5.21-3.46,12.21,12.21,0,0,0-4.19-3c-1.27-.59-1.54-.83-1.47-1.24s.36-1.48.36-1.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,333.72a13.81,13.81,0,0,0,.28-3.25c-.06-1,.64-1,.64-1a7.6,7.6,0,0,0,.06.93c.08.4.7.44.92.74.48.68.5,1.17,1.11,1.34s.66-.86,1.32-.9a1.1,1.1,0,0,1,.69.3,1.73,1.73,0,0,1-.09-.83c.15-.66,1.77-.87,2.92-1.15s.67.58,1.15,1.65a35.23,35.23,0,0,0,4.16,5.66,34.2,34.2,0,0,0,3,2.15c1.45.9,2,1.17,2.38,1.41s.57,1.17.39,1.74-3.31,2.12-6.75,1.56a7.61,7.61,0,0,1-5.79-3.65,9.52,9.52,0,0,0-3.73-3A7.81,7.81,0,0,1,147.5,336,4.6,4.6,0,0,1,147.35,333.72Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,333.72a13.81,13.81,0,0,0,.28-3.25c-.06-1,.64-1,.64-1a7.6,7.6,0,0,0,.06.93c.08.4.7.44.92.74.48.68.5,1.17,1.11,1.34s.66-.86,1.32-.9a1.1,1.1,0,0,1,.69.3,1.73,1.73,0,0,1-.09-.83c.15-.66,1.77-.87,2.92-1.15s.67.58,1.15,1.65a35.23,35.23,0,0,0,4.16,5.66,34.2,34.2,0,0,0,3,2.15c1.45.9,2,1.17,2.38,1.41s.57,1.17.39,1.74-3.31,2.12-6.75,1.56a7.61,7.61,0,0,1-5.79-3.65,9.52,9.52,0,0,0-3.73-3A7.81,7.81,0,0,1,147.5,336,4.6,4.6,0,0,1,147.35,333.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.51,337.23a35.23,35.23,0,0,1-4.16-5.66c-.48-1.07,0-1.92-1.15-1.65s-2.77.49-2.92,1.15.49,2.15,1.86,3.95a20.17,20.17,0,0,0,3.93,3.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.64,341.39c-.61.19-1.27.39-1.28.62a5,5,0,0,1-.26,2,1.64,1.64,0,0,1-1.29.67,16.34,16.34,0,0,1-4.61-.12,8.58,8.58,0,0,1-4.28-2.42c-1.38-1.4-1.66-2.1-3.43-3.13a32.33,32.33,0,0,1-3.22-1.8,3,3,0,0,0-.1.54,2,2,0,0,0,.81.59,21.74,21.74,0,0,1,3.29,1.67,21.44,21.44,0,0,1,2.47,2.48,8.79,8.79,0,0,0,4.47,2.42,12.57,12.57,0,0,0,6.3-.42c1.7-.7,1.76-1.05,1.9-1.27a3.89,3.89,0,0,0,0-1.7C166.3,341.21,166.07,341.25,165.64,341.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5,338.1a4.41,4.41,0,0,1,2.71-1.2,1,1,0,0,1,.48.48,5.4,5.4,0,0,0-2.62,1.2S157.55,338.55,157.5,338.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.19,335.67a7.17,7.17,0,0,0-3.28,1.36.64.64,0,0,1-.54-.48,6.31,6.31,0,0,1,3.42-1.39S159.2,335.35,159.19,335.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.89,334c-.77-.23-2.88.91-3.49,1.54a.54.54,0,0,1-.54-.55,6,6,0,0,1,3.56-1.64S158,333.5,157.89,334Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,332.31a5.72,5.72,0,0,0-3.69,1.34.67.67,0,0,1-.44-.58,5.15,5.15,0,0,1,3.77-1.38A1,1,0,0,1,156.77,332.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,315.22a6.75,6.75,0,0,0,1.3.64l.39-4.25.77,4.73s4.51.1,7.47-1.63c-.13-1.91-.13-4.59-.13-6.62s-.94-7.48-1.66-11.87a122.42,122.42,0,0,0-4.11-15.69,27.59,27.59,0,0,1-.95-13,65.89,65.89,0,0,0-9.15,4.37c-5.64,3.15-7.32,5-7.54,7s.92,6.13,3.12,10.76,10.25,18.44,10.25,18.44A14.35,14.35,0,0,0,143.76,315.22Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,315.22a6.75,6.75,0,0,0,1.3.64l.39-4.25.77,4.73s4.51.1,7.47-1.63c-.13-1.91-.13-4.59-.13-6.62s-.94-7.48-1.66-11.87a122.42,122.42,0,0,0-4.11-15.69,27.59,27.59,0,0,1-.95-13,65.89,65.89,0,0,0-9.15,4.37c-5.64,3.15-7.32,5-7.54,7s.92,6.13,3.12,10.76,10.25,18.44,10.25,18.44A14.35,14.35,0,0,0,143.76,315.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.49,303.9c-.6-2.56-6.78-19.7-10.38-25.4l-.34.22c3.58,5.66,9.72,22.73,10.32,25.28a17.22,17.22,0,0,1,.21,4.25c0,1.32-.06,2.94,0,5l.15-1.67.26,1.56c-.06-2,0-3.62,0-4.91A17.66,17.66,0,0,0,145.49,303.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.29,297.85a35.85,35.85,0,0,1-4.86,4.91c-2.51-4.4-5.85-10.35-7.16-13.09a37.3,37.3,0,0,1-2.85-7.91l7.33-3.45a13.43,13.43,0,0,0-4-4,5.62,5.62,0,0,0-1.11-.5,3.62,3.62,0,0,1,1.35.34,21.59,21.59,0,0,1,4.89,3.51,19.27,19.27,0,0,0,5.77-5.35c-.35,1.78-3.35,5.41-4.71,6.31,2,3.42,5.17,8.53,6.12,11.54S146.77,295.71,145.29,297.85Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bike--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.24,333.2l-3.05-1.77a.83.83,0,0,0-.85-.06L136,333.29a1.14,1.14,0,0,0-.45,1v2.82l5.65,3.26,3.33-1.93v-2.82A3.09,3.09,0,0,0,143.24,333.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.91,335.13l-3.06-1.77c-.71-.41-1.29,0-1.29,1v2.82l5.65,3.26V337.6A3.09,3.09,0,0,0,139.91,335.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.72,335.37l-3-1.72a.8.8,0,0,0-.81-.06h0l-26.42,15.26h0a1.1,1.1,0,0,0-.44,1v.87l5.48,3.16L141,338.63v-.87A3,3,0,0,0,139.72,335.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.92,349.55l-3.06-1.76a.83.83,0,0,0-.85-.07l-3.33,1.93a1.14,1.14,0,0,0-.44,1v2.83l5.64,3.26,3.33-1.93V352A3.12,3.12,0,0,0,114.92,349.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.59,351.48l-3.06-1.76c-.71-.42-1.29,0-1.29,1v2.83l5.64,3.26V354A3.1,3.1,0,0,0,111.59,351.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.93,375.59v2l-1.66,1v-2l-19.4-15.31a25.46,25.46,0,0,0-4.83-3.05l-33.62-16-2.77-1.6,1.39-.81,36.67,17.4a26,26,0,0,1,4.83,3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.27,376.55v2l-19.4-15.31a25.65,25.65,0,0,0-4.83-3l-32.23-15.3v-.17a3.27,3.27,0,0,0-1-2.23,1.78,1.78,0,0,0-.32-.24l-.1-.06,33.62,16a25.15,25.15,0,0,1,4.83,3.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,368.26l-3.06-1.76a.83.83,0,0,0-.85-.07l-3.33,1.93a1.15,1.15,0,0,0-.45,1v2.83l5.65,3.25,3.33-1.92v-2.83A3.1,3.1,0,0,0,204,368.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,370.19l-3-1.77c-.72-.41-1.3,0-1.3,1v2.83l5.65,3.25v-2.82A3.09,3.09,0,0,0,200.64,370.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.45,370.43l-3-1.71a.8.8,0,0,0-.82-.06h0l-26.43,15.26h0a1.13,1.13,0,0,0-.44,1v.87l5.48,3.16,26.43-15.26v-.86A3,3,0,0,0,200.45,370.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.65,384.61l-3.06-1.76a.83.83,0,0,0-.85-.07l-3.33,1.93a1.15,1.15,0,0,0-.44,1.05v2.82l5.64,3.26,3.34-1.93v-2.82A3.1,3.1,0,0,0,175.65,384.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,386.54l-3.06-1.76c-.71-.42-1.29,0-1.29,1v2.82l5.64,3.26V389A3.12,3.12,0,0,0,172.32,386.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.66,315.25l2.43-.37h0a21.93,21.93,0,0,1,6.34,10.3l14.14,50.7-3-1.74L174,325.56a21.91,21.91,0,0,0-6.34-10.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.57,375.88l-14.14-50.7a22,22,0,0,0-6.35-10.3h0l-1-3.18,1.85,1.71a21.92,21.92,0,0,1,6.22,10.2l14.42,51.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.19,317.42l-1.82-6.51c-6.05,1.71-10.72,3.09-15.41,6a46.72,46.72,0,0,0-12.21,10c-5.22,5.71-11.12,12.56-13.24,15.83l6.14,2.91,1.67-1c2.12-3.27,4.07-5.8,9.29-11.51A55.38,55.38,0,0,1,157.36,323a56.9,56.9,0,0,1,12.16-4.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.37,310.91l-1.67,1c-5.31,1.5-9.55,2.75-13.67,5C158.69,314,163.34,312.61,169.37,310.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.51,342.75l6.14,2.91c2.12-3.27,4.07-5.8,9.29-11.5,9.29-10.15,15.21-12.85,25.58-15.77l-1.82-6.51c-10.36,2.92-16.66,4.89-25.95,15C136.53,332.63,130.63,339.48,128.51,342.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.45 322.01 158.11 320.85 157.54 319.47 163.32 317.64 164.36 320.73 160.45 322.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.11 320.85 163.8 319.04 164.37 320.72 160.45 322.01 158.11 320.85",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.32,318.71c0,.23-.14.34-.32.24a.76.76,0,0,1-.31-.61c0-.23.14-.34.31-.23A.74.74,0,0,1,163.32,318.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.69,320.14c0,.23-.15.34-.32.24a.76.76,0,0,1-.31-.6c0-.24.14-.34.31-.24A.77.77,0,0,1,158.69,320.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,353.64c0-8.89-5.4-19.2-12.06-23.05-3-1.74-5.78-1.85-7.89-.63l-3.35,1.93c-2.54,1.48-4.15,4.89-4.15,9.74,0,8.88,5.4,19.19,12.06,23,3,1.74,5.78,1.85,7.89.63l3.34-1.92C185.75,361.91,187.36,358.49,187.36,353.64Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,353.64c0-8.89-5.4-19.2-12.06-23.05-3-1.74-5.78-1.85-7.89-.63l-3.35,1.93c-2.54,1.48-4.15,4.89-4.15,9.74,0,8.88,5.4,19.19,12.06,23,3,1.74,5.78,1.85,7.89.63l3.34-1.92C185.75,361.91,187.36,358.49,187.36,353.64Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.97,
    cy: 348.59,
    rx: 10.47,
    ry: 18.51,
    transform: "matrix(0.92, -0.39, 0.39, 0.92, -122.76, 95.17)",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.97,
    cy: 348.59,
    rx: 10.47,
    ry: 18.51,
    transform: "matrix(0.92, -0.39, 0.39, 0.92, -122.76, 95.17)",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.97,
    cy: 348.59,
    rx: 8.16,
    ry: 14.43,
    transform: "translate(-122.76 95.17) rotate(-23.05)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.57,351.82c0,4.13-2.5,6-5.6,4.24s-5.6-6.58-5.6-10.71,2.51-6,5.6-4.23S177.57,347.7,177.57,351.82Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2,356.94a4.75,4.75,0,0,1-2.33-.7c-3.15-1.82-5.71-6.7-5.71-10.89,0-2.24.75-4,2-4.7a3.8,3.8,0,0,1,3.87.29c3.15,1.82,5.71,6.7,5.71,10.88,0,2.25-.74,4-2,4.71A3.06,3.06,0,0,1,174.2,356.94Zm-4.46-16.29a2.64,2.64,0,0,0-1.33.35c-1.17.67-1.84,2.26-1.84,4.35,0,4.06,2.47,8.78,5.5,10.53a3.41,3.41,0,0,0,3.46.3c1.17-.68,1.84-2.26,1.84-4.36,0-4.05-2.47-8.77-5.5-10.52A4.29,4.29,0,0,0,169.74,340.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,332.51a18.55,18.55,0,0,1,5.18,4.32,28.47,28.47,0,0,1,3.74,5.66,31.13,31.13,0,0,1,2.38,6.35l.36,1.66.26,1.67.13,1.69v1.69l-.12-1.68-.22-1.67-.32-1.65-.41-1.63a33.17,33.17,0,0,0-2.43-6.25,30.93,30.93,0,0,0-3.62-5.64,16.39,16.39,0,0,0-1.1-1.27c-.36-.42-.79-.79-1.19-1.18l-.3-.29L174,334l-.65-.54c-.21-.18-.46-.32-.69-.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.45,322c6.22,5.79,15,11.71,17.66,11.11L177,329.19c-1.31.76-7.81-4.41-11.05-9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.11,333.12a.89.89,0,0,0,0-.59l-1.42-5,.25,1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5,317.64l-4.56,2.57c3.24,4.57,9.74,9.74,11.05,9h0C176.9,326.2,174.79,323.15,170.5,317.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.73 349.64 137.69 304.89 134.94 304.52 133.27 305.49 142.13 349.21 145.06 350.61 146.73 349.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.27 305.49 134.94 304.52 137.69 304.89 136.02 305.86 133.27 305.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.13 349.21 133.27 305.49 136.02 305.86 145.06 350.61 142.13 349.21",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.21 304.83 135.18 294.81 133.02 293.57 131.52 294.43 133.75 305.43 135.71 305.69 137.21 304.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.69 295.68 131.52 294.43 133.75 305.43 135.71 305.69 133.69 295.68",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.18 294.81 133.02 293.57 131.52 294.43 132.21 297.83 134.37 299.08 135.87 298.22 135.18 294.81",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.5 295.11 128.76 287.75 125.43 289.67 125.43 291.72 138.17 299.08 141.5 297.16 141.5 295.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.17 297.03 125.43 289.67 125.43 291.72 138.17 299.08 138.17 297.03",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.17 297.03 141.5 295.11 128.76 287.75 125.43 289.67 138.17 297.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.41 291.69 130.85 279.03 128.69 277.79 127.19 278.65 129.76 291.3 131.92 292.55 133.41 291.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.36 279.89 127.19 278.65 129.76 291.3 131.92 292.55 129.36 279.89",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.85 279.03 128.69 277.79 127.19 278.65 127.88 282.05 130.05 283.3 131.54 282.44 130.85 279.03",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.42,278a32.09,32.09,0,0,0-3.26-4.51s-5.85-9.13-13.29-5.49a4.75,4.75,0,0,0-2.73,3.35,5.92,5.92,0,0,0-.16,1.54,3.75,3.75,0,0,0,.73,2.24c.85,1.37,3.44,2.62,6.58,3.65l.67.22c1.12.34,2.26.64,3.39.95s2.24.62,3.34,1a13.55,13.55,0,0,1,1.33.52,5,5,0,0,1,.52.26,2.74,2.74,0,0,0,.6.27,1.37,1.37,0,0,0,.57.06,3.54,3.54,0,0,0,.45-.08,1.55,1.55,0,0,0,.36-.19,2.59,2.59,0,0,0,1-1.18A3,3,0,0,0,136.42,278Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.87,268c-2.26,1.1-3.61,3.32-2.06,5.79.85,1.37,3.44,2.62,6.57,3.65s8.54,2.14,9.81,3.33,3.34-.65,2.23-2.77a32.09,32.09,0,0,0-3.26-4.51S127.31,264.36,119.87,268Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.89,353.58,171.37,341s-4.46-3.76-8.14-6.62-15.71-11.83-20.72-14.73c-2-1.16-3.85-1.24-5.26-.42l-3.34,1.92c-1.7,1-2.78,3.27-2.78,6.51,0,5.92,3.6,12.8,8,15.37,5.49,3.16,12.56,5.52,17.77,7.51s14.62,5,14.62,5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.04 342.87 171.37 340.95 174.9 353.58 171.56 355.51 168.04 342.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,342.87s-4.46-3.76-8.14-6.61-15.71-11.84-20.73-14.73c-4.44-2.57-8,.15-8,6.08s3.6,12.8,8,15.37c5.49,3.16,12.56,5.52,17.77,7.51s14.62,5,14.62,5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.33,341.59c-3.85-2.2-7.11-8.25-7.1-13.38s3.12-7.42,6.94-5.22c4.76,2.75,15.71,11,19.78,14.34,3.09,2.53,6.53,5.67,8.15,7.07a2.46,2.46,0,0,1,.67,1.12l2,7.11c.12.45-.05.78-.35.68-3-1-8.92-2.95-12.62-4.36l-3.07-1.15A99,99,0,0,1,139.33,341.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.08,345.32a5.23,5.23,0,0,0-1.82-2.7c-2-1.59-6-4.64-8.71-6.56l-2.19-1.53c-4.16-2.86-10.12-6.81-10.24-6.89h0a7.78,7.78,0,0,0-.16,1.59c0,3.84,2.34,8.29,5.21,10l.14.07c5.57,3.17,18.26,7.77,18.26,7.77Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.08,345.32a5.23,5.23,0,0,0-1.82-2.7c-2-1.59-6-4.64-8.71-6.56l-2.19-1.53c-4.16-2.86-10.12-6.81-10.24-6.89h0a7.78,7.78,0,0,0-.16,1.59c0,3.84,2.34,8.29,5.21,10l.14.07c5.57,3.17,18.26,7.77,18.26,7.77Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59,334.22c0,2.52-1.53,3.68-3.42,2.59a8.21,8.21,0,0,1-3.41-6.53c0-2.52,1.53-3.68,3.41-2.59A8.19,8.19,0,0,1,142.59,334.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.58,333.64c0,1.77-1.08,2.59-2.41,1.82a5.77,5.77,0,0,1-2.4-4.6c0-1.77,1.07-2.59,2.4-1.82A5.77,5.77,0,0,1,141.58,333.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.24,333.27c0,1.07-.66,1.57-1.47,1.1a3.52,3.52,0,0,1-1.46-2.8c0-1.07.66-1.57,1.46-1.1A3.5,3.5,0,0,1,140.24,333.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.73,346.88l-.09,0c-.13-.05-12.74-4.63-18.24-7.76l-.12-.07c-2.82-1.63-5.11-6-5.11-9.78,0-1.94.62-3.41,1.7-4a3.16,3.16,0,0,1,3.2.27c2.22,1.28,4.17,2.56,6.22,3.92l.46.3a2.42,2.42,0,0,0,3-.24l.8-.74.15-.1L153,326.7l-.36-.26-3.16,1.82a1.53,1.53,0,0,0-.22.16l-.8.74a2,2,0,0,1-2.46.2l-.46-.31c-2.06-1.35-4-2.63-6.24-3.92a3.57,3.57,0,0,0-3.62-.28c-1.21.7-1.9,2.3-1.9,4.39,0,3.9,2.38,8.44,5.31,10.13l.14.08c5.26,3,17,7.31,18.19,7.75l1.12,3.88.48.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.09,343.13c0,.31-.19.45-.42.31a1,1,0,0,1-.42-.8c0-.31.19-.45.42-.32A1,1,0,0,1,167.09,343.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.81,354.34c0,.31-.19.45-.42.32a1,1,0,0,1-.42-.8c0-.31.19-.46.42-.32A1,1,0,0,1,170.81,354.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.87,333.5l-.29.22a7.74,7.74,0,0,0,.37.7l.29-.21c.1-.08.1-.3,0-.5S137,333.42,136.87,333.5Zm-.69-3.33-.41-.24c0,.12,0,.23,0,.35s0,.23,0,.35l.41.24c.14.08.26,0,.26-.2A.64.64,0,0,0,136.18,330.17Zm3,5.73c-.14-.09-.26,0-.26.2v.54l.26.17.27.13v-.54A.62.62,0,0,0,139.17,335.9Zm1.94.05c-.1.07-.1.29,0,.49l.29.55a1.9,1.9,0,0,0,.37-.28l-.29-.55C141.38,336,141.21,335.87,141.11,336Zm1.47-2.08-.41-.24c-.14-.08-.26,0-.26.2a.64.64,0,0,0,.26.5l.41.24c0-.12,0-.23,0-.35S142.59,334,142.58,333.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.58,332.89c0,.59-.36.87-.81.61A2,2,0,0,1,138,332c0-.59.36-.87.8-.61A1.93,1.93,0,0,1,139.58,332.89Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.74,313.78l.13,4.57a39.71,39.71,0,0,0,1.45,9.63l14.17,50.84,3,1.74,1-.6-14.5-52a40.45,40.45,0,0,1-1.45-9.66h0l-1.42-4.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,362.77c.84,2.65,1.62,5.32,2.37,8,.39,1.33.75,2.67,1.12,4s.72,2.69,1.07,4l0-.06,3,1.82c-1-.54-2-1.09-3.06-1.66h0v0c-.4-1.33-.79-2.66-1.16-4s-.77-2.67-1.13-4C176.38,368.16,175.67,365.48,175,362.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.53,380l-14.5-52a40.45,40.45,0,0,1-1.45-9.66l-1.42-4.87.13,4.56a40,40,0,0,0,1.45,9.65l14.76,52.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.53,380q-2.19-7.66-4.34-15.34l-4.31-15.36-4.26-15.37-1.07-3.84c-.35-1.28-.73-2.56-1-3.86a38.2,38.2,0,0,1-1-7.9h0l-1.39-4.88,1.45,4.87h0a41.11,41.11,0,0,0,1,7.89c.29,1.29.68,2.56,1,3.84l1.08,3.84,4.3,15.36,4.26,15.37Q181.45,372.26,183.53,380Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.47,334.36a.6.6,0,0,1-.51-.27l-8.33-12.5a.62.62,0,0,1,.17-.86.61.61,0,0,1,.85.17l8,12,1.59-.92a.63.63,0,0,1,.84.23.61.61,0,0,1-.23.84l-2.08,1.2A.58.58,0,0,1,136.47,334.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,324.25l-7.41-7.56a.85.85,0,0,0-.83-.23l-7.49,1.92a.86.86,0,0,0-.61.6l-.12.42a.87.87,0,0,0,.21.83l7.42,7.57a.85.85,0,0,0,.83.23l7.48-1.93a.83.83,0,0,0,.61-.6l.12-.41A.89.89,0,0,0,133.15,324.25Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,324.25l-7.41-7.56a.85.85,0,0,0-.83-.23l-7.49,1.92a.86.86,0,0,0-.61.6l-.12.42a.87.87,0,0,0,.21.83l7.42,7.57a.85.85,0,0,0,.83.23l7.48-1.93a.83.83,0,0,0,.61-.6l.12-.41A.89.89,0,0,0,133.15,324.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.73,326.46a.81.81,0,0,0,.77.21l7.86-2a.88.88,0,0,0-.21-.39l-2.85-2.91-4.56-4.65a.85.85,0,0,0-.83-.23l-.91.23-6.58,1.69a.94.94,0,0,0-.39.22Z",
    style: {
      fill: "#00FF00"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Body--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--leg--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.8,260.33c-2.73,3.26-6,6.4-7.43,11.3a12.4,12.4,0,0,0,2.44,12.08,69.51,69.51,0,0,0,6.6,7.08c1.68,1.61,3.86,3.59,3.86,3.59a11.15,11.15,0,0,0-4.4,4.74c-1.42,2.66-3.34,7.2-5.77,10.32l-.52.74s-2.1,3.7-1.5,4.22,2.82-1.09,4.09-1,4.5,1.91,4.5,1.91-.86-2.56-.11-4a17.09,17.09,0,0,1,2.38-2.6c2.67-2.48,7.46-6.92,10.62-9.89,3.46-3.26,3-5.81,2.05-8.58-.77-2.34-6.81-11.32-7.49-12.14a23.1,23.1,0,0,0,2.82-1.59,13.66,13.66,0,0,0,4.76-4.67,23,23,0,0,0,2.14-4.38s-1.16.75-5.64-.17S129.55,263.79,127.8,260.33Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,298.33a5.15,5.15,0,0,0,1.1,2.25l2.54-2.43-1.83,3.24a13.89,13.89,0,0,0,2.84,3.19,2.91,2.91,0,0,0,2.85,0s3.7-3.43,5.3-4.81,3.49-3.4,3.54-6.07-.84-4.31-2.34-7.1-5.36-8.29-5.36-8.29a22.39,22.39,0,0,0,5.8-4.55,17.05,17.05,0,0,0,3.29-6.26l-19-8.13s-1.18,1.37-3.57,4.26c-2,2.36-4,4.3-4.81,8.54s.09,7.27,2.72,11.25,10.57,10.88,10.57,10.88A12.91,12.91,0,0,0,129.11,298.33Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.63,282.63c-4.11-5.62-2.81-11.35-1-13.63.52-.67,1.07-1.33,1.59-1.95a36.11,36.11,0,0,0,4.11-5.66l-.36-.2a35.51,35.51,0,0,1-4.06,5.59c-.53.63-1.08,1.29-1.61,2-1.85,2.38-3.22,8.33,1,14.14a57.63,57.63,0,0,0,5.7,6.39c2.38,2.4,4.25,4.3,4,5.5-.14.65-1.8,2.69-3.07,4.18l.84-.8-.74,1.32c1.19-1.38,3.19-3.78,3.37-4.61.31-1.42-1.54-3.29-4.1-5.88A55.77,55.77,0,0,1,125.63,282.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,274.14a3.62,3.62,0,0,0-1.35-.34,5.62,5.62,0,0,1,1.11.5,13.43,13.43,0,0,1,4,4l1.13-.66A21.59,21.59,0,0,0,134,274.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2,327.67c0,.49-.15.8-2,1a13,13,0,0,1-6.55-1.48,9.73,9.73,0,0,1-4.14-5,14,14,0,0,0-3.36-4.51c-1.08-1-1.28-1.29-1.09-1.67s.8-1.37.8-1.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.09,312.9c.62-1.27,1.46-1.48,1.72-2.58a1.13,1.13,0,0,1,1.29-.88l-.52.74a2.33,2.33,0,0,0,.25,1c.28.81.16,1.31.71,1.66s.91-.66,1.58-.5a1.1,1.1,0,0,1,.59.5,1.73,1.73,0,0,1,.16-.85c.34-.61,2-.34,3.24-.27s.5.78.65,2a37,37,0,0,0,2.45,6.87,34.94,34.94,0,0,0,2.31,3c1.17,1.33,1.59,1.75,1.93,2.11s.22,1.33-.13,1.84-3.92,1.12-7.16-.46a7.92,7.92,0,0,1-4.67-5.35,9.69,9.69,0,0,0-2.82-4.06,9.51,9.51,0,0,1-2.11-2.48A4.82,4.82,0,0,1,120.09,312.9Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.09,312.9c.62-1.27,1.46-1.48,1.72-2.58a1.13,1.13,0,0,1,1.29-.88l-.52.74a2.33,2.33,0,0,0,.25,1c.28.81.16,1.31.71,1.66s.91-.66,1.58-.5a1.1,1.1,0,0,1,.59.5,1.73,1.73,0,0,1,.16-.85c.34-.61,2-.34,3.24-.27s.5.78.65,2a37,37,0,0,0,2.45,6.87,34.94,34.94,0,0,0,2.31,3c1.17,1.33,1.59,1.75,1.93,2.11s.22,1.33-.13,1.84-3.92,1.12-7.16-.46a7.92,7.92,0,0,1-4.67-5.35,9.69,9.69,0,0,0-2.82-4.06,9.51,9.51,0,0,1-2.11-2.48A4.82,4.82,0,0,1,120.09,312.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.21,320.59a37,37,0,0,1-2.45-6.87c-.15-1.2.57-1.91-.65-2s-2.9-.34-3.24.27-.15,2.28.67,4.48a21.31,21.31,0,0,0,2.84,4.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06,326.25c-.66,0-1.38,0-1.46.23a5.17,5.17,0,0,1-.85,1.88,1.71,1.71,0,0,1-1.48.27,17.44,17.44,0,0,1-4.54-1.49,9,9,0,0,1-3.53-3.69c-1-1.8-1-2.57-2.47-4.13a31.35,31.35,0,0,1-2.75-3,3.7,3.7,0,0,0-.27.51,2.25,2.25,0,0,0,.64.83,25.62,25.62,0,0,1,2.86,2.91,23.3,23.3,0,0,1,1.72,3.2,9.06,9.06,0,0,0,3.71,3.74A13.12,13.12,0,0,0,134,329c1.89-.19,2.07-.52,2.27-.69a4.08,4.08,0,0,0,.52-1.69C136.77,326.27,136.53,326.24,136.06,326.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,320.55a4.58,4.58,0,0,1,3.05-.38,1,1,0,0,1,.34.62,5.56,5.56,0,0,0-3,.41S128.87,321,129,320.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.36,318.65a7.33,7.33,0,0,0-3.67.36.67.67,0,0,1-.39-.64,6.59,6.59,0,0,1,3.81-.35S131.46,318.32,131.36,318.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58,316.55c-.7-.46-3.13,0-3.92.48a.56.56,0,0,1-.38-.7,6.32,6.32,0,0,1,4-.57S130.79,316.12,130.58,316.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,314.59a5.85,5.85,0,0,0-4.06.22.67.67,0,0,1-.26-.71,5.32,5.32,0,0,1,4.14-.24A1,1,0,0,1,130,314.59Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-5",
    d: "M151.45,233.4c3.68.39,6,1.67,8.09,5.77.57,1.13,1.7,3.15,4,7.2,2.15,3.84,4.28,7.77,4.28,7.77s3.72,2.51,6.42,4.27,6.68,4.36,7.82,4.56a27.08,27.08,0,0,0,4.09,0l-4.42,7.65c-1.31-.54-1.07-.84-3.13-1.94-2.34-1.25-11.95-5-13.63-5.85-3.33-1.67-3.93-2.41-5.82-5.4-3.17-5-6.49-10.95-6.49-10.95Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.8,259.37a17.81,17.81,0,0,0,3.29-9.92c-.1-2.68-1.31-9.51-.4-11.77s6.41-3.75,12.8-4.62,9,.93,10.29,3.37,3.09,9,2.82,13.32a7.71,7.71,0,0,1-4,6.12l-3.36,4.58c-1.13,1.52-2.42,7-2.42,7s-1.71,2.32-8.57,1.5A12,12,0,0,1,127.8,259.37Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.49,233.06c-6.39.87-11.88,2.36-12.8,4.62s.3,9.09.4,11.77a13.22,13.22,0,0,1-.35,3.18h0c.76,2,7.27,7.08,13.68,7,5,0,6.64-1.75,7-2.11l.08-.12h0l1.16-1.57a9.64,9.64,0,0,0,5.1-7.08c.61-4.24-1.83-9.17-3.23-11.55a12.34,12.34,0,0,0-3-3.84A24,24,0,0,0,143.49,233.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,234.28a24.76,24.76,0,0,1,3.84,5c1.59,2.62,4.35,4.05,8.3,3.71,4.3-.38,3.09-3,2.16-5.37a17.37,17.37,0,0,0-2.65-4.68A41.35,41.35,0,0,0,137,234.28Z",
    style: {
      fill: "#b16668"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M149.44,255.13c-1.6,1.73-7.83,2.73-11.35-1.45C138.64,257.21,146,259.87,149.44,255.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.86,260.48l2.46-3.64a13.83,13.83,0,0,0,2.84,4.69,13.61,13.61,0,0,0,12.19,4.28c2.56-.57,3.27-1.26,3.27-1.26l-.94,3.92a6.81,6.81,0,0,1-4.38,1.59c-3.74.18-8.83-.48-12.65-5.28A25.15,25.15,0,0,1,126.86,260.48Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.86,260.48l2.46-3.64a13.83,13.83,0,0,0,2.84,4.69,13.61,13.61,0,0,0,12.19,4.28c2.56-.57,3.27-1.26,3.27-1.26l-.94,3.92a6.81,6.81,0,0,1-4.38,1.59c-3.74.18-8.83-.48-12.65-5.28A25.15,25.15,0,0,1,126.86,260.48Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.85,216.75a2.41,2.41,0,0,0-.12.65,1.63,1.63,0,0,0,.15.75,1.12,1.12,0,0,0,.25.4c.07.06.16.12.23.19a2.9,2.9,0,0,1,.44.6,3.37,3.37,0,0,1,.43,1.39,3.23,3.23,0,0,1-.76,2.3,10.35,10.35,0,0,0-1.39,1.5,5.68,5.68,0,0,0-.44,1.87,2.25,2.25,0,0,1-.88,1.65c-.81.46-1.8,0-2.73-.06a3.51,3.51,0,0,0-1.83.53,9.28,9.28,0,0,0-.83.56,1.49,1.49,0,0,1-.58.28,3.9,3.9,0,0,1-1.08,0,6.57,6.57,0,0,1-1.46-.4,4.76,4.76,0,0,0-2-.39,2.84,2.84,0,0,0-.49.1,3.6,3.6,0,0,0-.37.22l-.93.57,0,0a3.55,3.55,0,0,1-2.77.64c-1-.31-1.78-1.43-2.86-1.38a10.38,10.38,0,0,0-1.22.31,2,2,0,0,1-2-1,6.09,6.09,0,0,1-.28-.75,4.85,4.85,0,0,0-.16-.63,2,2,0,0,0-1-.93c-.62-.28-1.32-.37-1.95-.62a1.86,1.86,0,0,1-1.3-1.44,3,3,0,0,1,.51-1.5,2.08,2.08,0,0,0,.27-1.09,4.61,4.61,0,0,0-.2-1,2.81,2.81,0,0,1-.05-2.13,5.59,5.59,0,0,1,1.45-1.62,4.83,4.83,0,0,0,1.4-1.65,16.73,16.73,0,0,0,.45-2,3.67,3.67,0,0,1,3-2.6,3.52,3.52,0,0,0,1.26-.22,3.24,3.24,0,0,0,1-1.34,4.14,4.14,0,0,1,.34-.48,4.47,4.47,0,0,1,4.56-1.49,3.26,3.26,0,0,1,1,.47l.31.24a1.42,1.42,0,0,0,.95.15c.47,0,.93-.09,1.39-.16s1.2-.17,1.8-.21a4.37,4.37,0,0,1,3.85,1.38c.5.69.66,1.59,1.17,2.28a4.44,4.44,0,0,0,1,1,1.45,1.45,0,0,0,.44.27,3,3,0,0,1,.45.17,3.07,3.07,0,0,1,.79.54,3.44,3.44,0,0,1,1,1.64,3.69,3.69,0,0,1-.14,2C160.94,216.43,160.89,216.59,160.85,216.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.72,214.71s1.92,2.44.45,9.79c-.91,4.52-2.47,6.56-4.1,7.21a9.58,9.58,0,0,1-4.61-.14,5,5,0,0,0-.19.59c-.2.71.34.81.34.81s3.4,7.05-.79,7a14.16,14.16,0,0,1-6.74-2.39,21.61,21.61,0,0,1-4-3.33c1.67-.44,1.69-.89,2.1-2.35.74-2.61,1.4-6.82,1.4-6.82a1.84,1.84,0,0,1-2.71-.34c-1.6-1.74-1.51-4.62.13-5.57,2-1.15,3.27.23,3.72,1.63s1.59,1.47,2.1,0c.74-2.09.91-6,2.89-6.43C149.2,213.9,151.48,219.3,156.72,214.71Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.51,221.72a1,1,0,0,1-.48.83,1.07,1.07,0,0,1-.52.17c-.11,0-.08.18,0,.7l.05.34a.34.34,0,0,1-.24.4h0a.33.33,0,0,1-.4-.25l-.47-1.93a1.09,1.09,0,0,1,.77-1.33A1.05,1.05,0,0,1,140.51,221.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,222.93c-.07.75.74,1.44,1.81,1.54s2-.43,2.07-1.18-.74-1.43-1.81-1.53S144.11,222.18,144,222.93Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,223.73c-.07.75.74,1.44,1.82,1.54s2-.43,2.07-1.18-.75-1.44-1.82-1.54S155.11,223,155,223.73Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.77,225.93l2.64,1a1.4,1.4,0,0,1-1.81.87A1.49,1.49,0,0,1,148.77,225.93Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.38,218.69l-2,.66A1,1,0,0,1,148,218,1.13,1.13,0,0,1,149.38,218.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.84,219l1.73,1.27a1,1,0,0,0-.19-1.49A1.13,1.13,0,0,0,154.84,219Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.8 220.24 151.46 225.08 154.35 224.54 151.8 220.24",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73,225.93s-.47,2.54,1,4a10.81,10.81,0,0,0,5.57,2.66.79.79,0,0,1,0-.48,5,5,0,0,1,.19-.59h0a14,14,0,0,1-5-2.22A4.79,4.79,0,0,1,141.73,225.93Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.05,221.3a.84.84,0,0,0,.65,1,.8.8,0,0,0,1-.62.85.85,0,0,0-.65-1A.79.79,0,0,0,154.05,221.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,220.88a.85.85,0,0,0,.65,1,.8.8,0,0,0,1-.63.85.85,0,0,0-.66-1A.78.78,0,0,0,148,220.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.71,226.72a1.84,1.84,0,0,1,.33,0,2,2,0,0,1,1.38,1.12,1.44,1.44,0,0,1-.82-.05A1.47,1.47,0,0,1,148.71,226.72Z",
    style: {
      fill: "#ffa8a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Handlebar--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.93,292.69l-2.6-.34-2.4,1.38,6.29,29c1.12,1.11,2.21,2.23,3.24,3.34l2.4-1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.53 294.08 167.93 292.69 165.33 292.35 162.94 293.73 165.53 294.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,293.73l6.29,29c1.12,1.11,2.21,2.23,3.24,3.34l-6.93-32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.24 292.86 164.19 278.86 162.14 278.59 160.48 279.55 163.53 293.55 165.57 293.82 167.24 292.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.48 279.55 163.53 293.55 165.57 293.82 162.53 279.82 160.48 279.55",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,288.5l-.22,0c-1.49-.25-1.86-1.1-1.94-1.57s0-1.4,1.28-2.16l25-14.43a7.81,7.81,0,0,1,4.65-.83L181,271a.58.58,0,0,0,.69-.35l5.72-9.91a1.27,1.27,0,0,1,2.2,1.28l-5.71,9.9a3.12,3.12,0,0,1-3.33,1.59l-8.69-1.5a5.37,5.37,0,0,0-2.95.53l-24.3,14a1.22,1.22,0,0,1,.17.88A1.27,1.27,0,0,1,143.55,288.5Zm.21-1.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.11 262.7 161.11 268.47 156.11 282.9 157.78 283.86 167.77 278.09 172.77 263.66 171.11 262.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.78 283.86 162.78 269.43 172.77 263.66 167.77 278.09 157.78 283.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.11 268.47 162.78 269.43 157.78 283.86 156.11 282.9 161.11 268.47",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.61,290a4,4,0,0,1-.59,0l-8.69-1.5a1.27,1.27,0,1,1,.43-2.5l8.69,1.49a.59.59,0,0,0,.7-.35l5.71-9.91a1.27,1.27,0,0,1,2.21,1.27l-5.72,9.91A3.1,3.1,0,0,1,152.61,290Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.43,282.45a43.93,43.93,0,0,0,4.16,4.24,10.76,10.76,0,0,0,4.28,1.33c.85,0,2.17-.89,3.29-1.86a2.12,2.12,0,0,0,1.43-1.36,1.42,1.42,0,0,0,.91-.3c.87-.86.45-2.32-.24-4.62l-1,1.68c-.19.33-1.06.38-1.63,0a2.06,2.06,0,0,1-.76-.94l1.21-2.09c-1.38-.24-1.68-.53-2.87-.67s-2.43.11-3.48-.53a28.49,28.49,0,0,1-4.14-4.11c-4.1-4.43-7.85-9.33-7.85-9.33l-3.15-16s-.17-10.25-3.32-12.37c-2.16.48-6.77,2.3-7.42,6.59-.56,3.71.94,6.59,1.31,8.3s1.51,6.73,2.75,13.1c.7,3.58,1.15,5.17,4.83,8.35C138.18,274.83,145.18,281.05,146.43,282.45Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.62,273.21c-1.42-1.44-2.83-3-4.18-4.5s-2.52-3.15-3.82-4.7l0,0v-.05c-.27-1.33-.54-2.66-.79-4l-.77-4c-.48-2.67-1-5.34-1.4-8,.62,2.64,1.18,5.3,1.74,8l.81,4c.28,1.33.54,2.66.79,4l0-.09c1.28,1.57,2.51,3.26,3.81,4.82Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.83,286l-1.41-.18v0c.45.14.91.27,1.37.39l1,.22.38-.31C157.7,286.15,157.26,286.1,156.83,286Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67,287.16a5.31,5.31,0,0,1-1.14-.06l-1.39-.22v0c.45.14.91.27,1.37.39l.84.2c.22-.13.44-.28.67-.44A.92.92,0,0,1,156.67,287.16Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.59,284.8h0a12.57,12.57,0,0,1-1.36-.15l-1.42-.19v0c.45.15.91.28,1.37.4l1.22.28A3.24,3.24,0,0,0,159.59,284.8Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.68,279.1a4.92,4.92,0,0,1,2.22,1.51l.29-.48A3.73,3.73,0,0,0,154.68,279.1Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.74,263.5c.37.49,1.75,2.11,1.81,3s-.9,1.4-.9,1.4.4,1.59-.91,2.08c0,0,.15,1-1.18,1.36-.32.94-.55.92-1.71,1s-1.41.14-1.95-.4a3.58,3.58,0,0,1-.94-2.39c0-.8.7-1.52,1.06-1-.19-1.55.11-3.57,2.57-3.84.5-.06.75,1.3.75,1.3Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.38,262.25c1.2.59,2.78.43,4.33.45s2.12.49,2.49,1.66-.61,3.05-.61,4.11-1.47.69-1.88-.44a6.08,6.08,0,0,1-.4-1.93Z",
    style: {
      fill: "#b16668"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottles--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Water--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottle-of-water--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottle--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.05,369.72h0c0-1.81-1.66-3.54-2.39-4.23a3.39,3.39,0,0,1-.73-.76c-.1-.2-.08-.31-.08-.7h-3.24c0,.39,0,.5-.08.7s-.34.4-.73.76c-.72.69-2.39,2.42-2.39,4.23h0a1.61,1.61,0,0,0,.07.49,1.66,1.66,0,0,0-.07.49h0v.79h0a1.47,1.47,0,0,0,.07.46,1.55,1.55,0,0,0-.07.52h0v1a1.65,1.65,0,0,0,.28.91l.21.3a1.66,1.66,0,0,1,.28.92,1.59,1.59,0,0,1-.18.74l-.41.78a1.63,1.63,0,0,0-.18.75v10.91h0a2.38,2.38,0,0,0,1.41,2,7.52,7.52,0,0,0,6.82,0,2.38,2.38,0,0,0,1.41-2h0V377.85a1.63,1.63,0,0,0-.18-.75l-.41-.78a1.59,1.59,0,0,1-.18-.74,1.66,1.66,0,0,1,.28-.92l.21-.3a1.65,1.65,0,0,0,.28-.91v-1h0A1.54,1.54,0,0,0,162,372a1.82,1.82,0,0,0,.06-.46h0v-.79h0a1.66,1.66,0,0,0-.07-.49,1.61,1.61,0,0,0,.07-.49Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.05,369.72h0c0-1.81-1.66-3.54-2.39-4.23a3.39,3.39,0,0,1-.73-.76c-.1-.2-.08-.31-.08-.7h-3.24c0,.39,0,.5-.08.7s-.34.4-.73.76c-.72.69-2.39,2.42-2.39,4.23h0a1.61,1.61,0,0,0,.07.49,1.66,1.66,0,0,0-.07.49h0v.79h0a1.47,1.47,0,0,0,.07.46,1.55,1.55,0,0,0-.07.52h0v1a1.65,1.65,0,0,0,.28.91l.21.3a1.66,1.66,0,0,1,.28.92,1.59,1.59,0,0,1-.18.74l-.41.78a1.63,1.63,0,0,0-.18.75v10.91h0a2.38,2.38,0,0,0,1.41,2,7.52,7.52,0,0,0,6.82,0,2.38,2.38,0,0,0,1.41-2h0V377.85a1.63,1.63,0,0,0-.18-.75l-.41-.78a1.59,1.59,0,0,1-.18-.74,1.66,1.66,0,0,1,.28-.92l.21-.3a1.65,1.65,0,0,0,.28-.91v-1h0A1.54,1.54,0,0,0,162,372a1.82,1.82,0,0,0,.06-.46h0v-.79h0a1.66,1.66,0,0,0-.07-.49,1.61,1.61,0,0,0,.07-.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.41,371.49a2.41,2.41,0,0,0,1.41,2,7.58,7.58,0,0,0,6.82,0,2.41,2.41,0,0,0,1.41-2v-.79a2.38,2.38,0,0,1-1.41,2,7.52,7.52,0,0,1-6.82,0,2.38,2.38,0,0,1-1.41-2Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.41,373.47a2.41,2.41,0,0,0,1.41,2,7.58,7.58,0,0,0,6.82,0,2.41,2.41,0,0,0,1.41-2v-1.06a2.41,2.41,0,0,1-1.41,2,7.58,7.58,0,0,1-6.82,0,2.41,2.41,0,0,1-1.41-2Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.05,369.72a1.06,1.06,0,0,1,0,.25.13.13,0,0,1,0,.06,1.16,1.16,0,0,1,0,.18,2.74,2.74,0,0,1-1.34,1.48,7.52,7.52,0,0,1-6.82,0,2.78,2.78,0,0,1-1.34-1.48v0a.19.19,0,0,1,0-.07,1.83,1.83,0,0,1-.05-.4c0-1.81,1.67-3.54,2.39-4.23a3.39,3.39,0,0,0,.73-.76c.1-.2.08-.31.08-.7h3.24c0,.39,0,.5.08.7a3.39,3.39,0,0,0,.73.76C160.39,366.18,162.05,367.91,162.05,369.72Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,378.82a6.88,6.88,0,0,1-6.22,0c-1.17-.68-1.55-1.65-1.12-2.51h0l-.41.78a1.63,1.63,0,0,0-.18.75v10.91a2.38,2.38,0,0,0,1.41,2,7.52,7.52,0,0,0,6.82,0,2.38,2.38,0,0,0,1.41-2V377.85a1.63,1.63,0,0,0-.18-.75l-.41-.78h0C161.89,377.17,161.52,378.14,160.34,378.82Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.41,371.49a2.41,2.41,0,0,0,1.41,2,7.58,7.58,0,0,0,6.82,0,2.41,2.41,0,0,0,1.41-2v-.79a2.38,2.38,0,0,1-1.41,2,7.52,7.52,0,0,1-6.82,0,2.38,2.38,0,0,1-1.41-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.41,373.47a2.41,2.41,0,0,0,1.41,2,7.58,7.58,0,0,0,6.82,0,2.41,2.41,0,0,0,1.41-2v-1.06a2.41,2.41,0,0,1-1.41,2,7.58,7.58,0,0,1-6.82,0,2.41,2.41,0,0,1-1.41-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.05,369.72a1.06,1.06,0,0,1,0,.25.13.13,0,0,1,0,.06,1.16,1.16,0,0,1,0,.18,2.74,2.74,0,0,1-1.34,1.48,7.52,7.52,0,0,1-6.82,0,2.78,2.78,0,0,1-1.34-1.48v0a.19.19,0,0,1,0-.07,1.83,1.83,0,0,1-.05-.4c0-1.81,1.67-3.54,2.39-4.23a3.39,3.39,0,0,0,.73-.76c.1-.2.08-.31.08-.7h3.24c0,.39,0,.5.08.7a3.39,3.39,0,0,0,.73.76C160.39,366.18,162.05,367.91,162.05,369.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,378.82a6.88,6.88,0,0,1-6.22,0c-1.17-.68-1.55-1.65-1.12-2.51h0l-.41.78a1.63,1.63,0,0,0-.18.75v10.91a2.38,2.38,0,0,0,1.41,2,7.52,7.52,0,0,0,6.82,0,2.38,2.38,0,0,0,1.41-2V377.85a1.63,1.63,0,0,0-.18-.75l-.41-.78h0C161.89,377.17,161.52,378.14,160.34,378.82Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--water--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.48,370.37a1.26,1.26,0,0,1,.05.33v.79a1.12,1.12,0,0,1-.05.31l0,.15,0,.14a1.12,1.12,0,0,1,.05.36l0,.54h0v.46a1.1,1.1,0,0,1-.19.61l-.21.31a2.08,2.08,0,0,0-.13,2.19l.41.79a1.19,1.19,0,0,1,.12.5v10.91a1.92,1.92,0,0,1-1.15,1.52,7.07,7.07,0,0,1-6.3,0,1.92,1.92,0,0,1-1.15-1.52V377.85a1.06,1.06,0,0,1,.13-.5l.4-.79a2.08,2.08,0,0,0-.13-2.19l-.21-.31a1.1,1.1,0,0,1-.19-.61V373h0v-.54a1.11,1.11,0,0,1,0-.36l0-.14,0-.15a1.12,1.12,0,0,1,0-.31v-.79a1,1,0,0,1,.06-.33l0-.16,0-.15a1,1,0,0,1-.06-.34,3.77,3.77,0,0,1,.59-1.86h0l0-.06s0,0,0,0a2.55,2.55,0,0,1,.9-.8,6.08,6.08,0,0,1,5.51,0,2.6,2.6,0,0,1,.89.8l0,0,0,.06h0a3.77,3.77,0,0,1,.59,1.86,1.33,1.33,0,0,1-.05.34l0,.15Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.48,370.37a1.26,1.26,0,0,1,.05.33v.79a1.12,1.12,0,0,1-.05.31l0,.15,0,.14a1.12,1.12,0,0,1,.05.36l0,.54h0v.46a1.1,1.1,0,0,1-.19.61l-.21.31a2.08,2.08,0,0,0-.13,2.19l.41.79a1.19,1.19,0,0,1,.12.5v10.91a1.92,1.92,0,0,1-1.15,1.52,7.07,7.07,0,0,1-6.3,0,1.92,1.92,0,0,1-1.15-1.52V377.85a1.06,1.06,0,0,1,.13-.5l.4-.79a2.08,2.08,0,0,0-.13-2.19l-.21-.31a1.1,1.1,0,0,1-.19-.61V373h0v-.54a1.11,1.11,0,0,1,0-.36l0-.14,0-.15a1.12,1.12,0,0,1,0-.31v-.79a1,1,0,0,1,.06-.33l0-.16,0-.15a1,1,0,0,1-.06-.34,3.77,3.77,0,0,1,.59-1.86h0l0-.06s0,0,0,0a2.55,2.55,0,0,1,.9-.8,6.08,6.08,0,0,1,5.51,0,2.6,2.6,0,0,1,.89.8l0,0,0,.06h0a3.77,3.77,0,0,1,.59,1.86,1.33,1.33,0,0,1-.05.34l0,.15Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,370.14a6.08,6.08,0,0,1-5.51,0c-1.07-.61-1.39-1.5-1-2.28h0l0-.06s0,0,0,0a2.55,2.55,0,0,1,.9-.8,6.08,6.08,0,0,1,5.51,0,2.6,2.6,0,0,1,.89.8l0,0,0,.06h0C161.37,368.64,161.06,369.53,160,370.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.51,372.77a3.73,3.73,0,0,1-.87.69,7.58,7.58,0,0,1-6.82,0,3.73,3.73,0,0,1-.87-.69V373h0v.46a.78.78,0,0,0,0,.26,3.76,3.76,0,0,0,.85.67,7.58,7.58,0,0,0,6.82,0,3.83,3.83,0,0,0,.86-.67,1.22,1.22,0,0,0,0-.26V373h0Zm-.51,3.79a2.1,2.1,0,0,1-.25-1,1.5,1.5,0,0,1,0-.22l-.13.08a7.58,7.58,0,0,1-6.82,0l-.12-.08c0,.07,0,.14,0,.22a2.1,2.1,0,0,1-.25,1l-.4.79a.85.85,0,0,0-.1.28,2.63,2.63,0,0,0,1.16,1.19,6.88,6.88,0,0,0,6.22,0,2.63,2.63,0,0,0,1.16-1.19,1.15,1.15,0,0,0-.09-.28Zm-.36-4.87a7.52,7.52,0,0,1-6.82,0,3.63,3.63,0,0,1-.89-.7v.5a1.12,1.12,0,0,0,0,.31l0,.15,0,.08a3.43,3.43,0,0,0,.82.64,7.52,7.52,0,0,0,6.82,0,3.5,3.5,0,0,0,.83-.64l0-.08,0-.15a1.12,1.12,0,0,0,.05-.31V371A3.63,3.63,0,0,1,160.64,371.69Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.51,372.77a3.73,3.73,0,0,1-.87.69,7.58,7.58,0,0,1-6.82,0,3.73,3.73,0,0,1-.87-.69V373h0v.46a.78.78,0,0,0,0,.26,3.76,3.76,0,0,0,.85.67,7.58,7.58,0,0,0,6.82,0,3.83,3.83,0,0,0,.86-.67,1.22,1.22,0,0,0,0-.26V373h0Zm-.51,3.79a2.1,2.1,0,0,1-.25-1,1.5,1.5,0,0,1,0-.22l-.13.08a7.58,7.58,0,0,1-6.82,0l-.12-.08c0,.07,0,.14,0,.22a2.1,2.1,0,0,1-.25,1l-.4.79a.85.85,0,0,0-.1.28,2.63,2.63,0,0,0,1.16,1.19,6.88,6.88,0,0,0,6.22,0,2.63,2.63,0,0,0,1.16-1.19,1.15,1.15,0,0,0-.09-.28Zm-.36-4.87a7.52,7.52,0,0,1-6.82,0,3.63,3.63,0,0,1-.89-.7v.5a1.12,1.12,0,0,0,0,.31l0,.15,0,.08a3.43,3.43,0,0,0,.82.64,7.52,7.52,0,0,0,6.82,0,3.5,3.5,0,0,0,.83-.64l0-.08,0-.15a1.12,1.12,0,0,0,.05-.31V371A3.63,3.63,0,0,1,160.64,371.69Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,386.9a6.4,6.4,0,0,0-5.6,0,1.87,1.87,0,0,0-1.16,1.54v.2c0,.49.38,1,1.06,1.34a6.7,6.7,0,0,0,5.8,0c.68-.38,1.06-.85,1.06-1.34v-.19A1.89,1.89,0,0,0,160,386.9Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,386.9a6.4,6.4,0,0,0-5.6,0,1.87,1.87,0,0,0-1.16,1.54v.2c0,.49.38,1,1.06,1.34a6.7,6.7,0,0,0,5.8,0c.68-.38,1.06-.85,1.06-1.34v-.19A1.89,1.89,0,0,0,160,386.9Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M154.79,388.73V377.81a1.6,1.6,0,0,1,.19-.74l.41-.79a1.59,1.59,0,0,0,.18-.74,1.63,1.63,0,0,0-.28-.91l-.21-.31a1.56,1.56,0,0,1-.29-.91v-1h0a1.54,1.54,0,0,1,.06-.52,1.83,1.83,0,0,1-.07-.46h0v-.78h0a1.74,1.74,0,0,1,.08-.5,1.62,1.62,0,0,1-.08-.49h0a6.53,6.53,0,0,1,2-4.23,3.39,3.39,0,0,0,.73-.76,1.34,1.34,0,0,0,.08-.66h-2c0,.39,0,.5-.08.7s-.34.4-.73.76c-.72.69-2.39,2.42-2.39,4.23h0a1.61,1.61,0,0,0,.07.49,1.66,1.66,0,0,0-.07.49h0v.79h0a1.47,1.47,0,0,0,.07.46,1.55,1.55,0,0,0-.07.52h0v1a1.65,1.65,0,0,0,.28.91l.21.3a1.66,1.66,0,0,1,.28.92,1.59,1.59,0,0,1-.18.74l-.41.78a1.63,1.63,0,0,0-.18.75v10.91a2.38,2.38,0,0,0,1.41,2,7.45,7.45,0,0,0,4.73.71,6.26,6.26,0,0,1-2.34-.75A2.4,2.4,0,0,1,154.79,388.73Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.64,380.92a7.52,7.52,0,0,1-6.82,0,2.41,2.41,0,0,1-1.41-2v4.79a2.41,2.41,0,0,0,1.41,2,7.58,7.58,0,0,0,6.82,0,2.41,2.41,0,0,0,1.41-2V379A2.41,2.41,0,0,1,160.64,380.92Z",
    style: {
      fill: "#00FF00"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cap--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.65,363a3.16,3.16,0,0,0-2.84,0,1,1,0,0,0-.58.82v.32a1,1,0,0,0,.58.82,3.16,3.16,0,0,0,2.84,0,1,1,0,0,0,.58-.82v-.32A1,1,0,0,0,158.65,363Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.65,363a3.16,3.16,0,0,0-2.84,0,1,1,0,0,0-.58.82v.32a1,1,0,0,0,.58.82,3.16,3.16,0,0,0,2.84,0,1,1,0,0,0,.58-.82v-.32A1,1,0,0,0,158.65,363Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,364.63a.87.87,0,0,1,0-1.64,3.16,3.16,0,0,1,2.84,0,.87.87,0,0,1,0,1.64A3.16,3.16,0,0,1,155.81,364.63Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,364.63a.87.87,0,0,1,0-1.64,3.16,3.16,0,0,1,2.84,0,.87.87,0,0,1,0,1.64A3.16,3.16,0,0,1,155.81,364.63Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,364.63a.87.87,0,0,1,0-1.64,3.16,3.16,0,0,1,2.84,0,.87.87,0,0,1,0,1.64A3.16,3.16,0,0,1,155.81,364.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.61,362.57a3.05,3.05,0,0,0-2.76,0,1,1,0,0,0-.57.79v.32a1,1,0,0,0,.57.79,3.05,3.05,0,0,0,2.76,0,1,1,0,0,0,.57-.79v-.31A1,1,0,0,0,158.61,362.57Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.61,362.57a3.05,3.05,0,0,0-2.76,0,1,1,0,0,0-.57.79v.32a1,1,0,0,0,.57.79,3.05,3.05,0,0,0,2.76,0,1,1,0,0,0,.57-.79v-.31A1,1,0,0,0,158.61,362.57Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.85,364.16a.84.84,0,0,1,0-1.59,3.05,3.05,0,0,1,2.76,0,.84.84,0,0,1,0,1.59A3.05,3.05,0,0,1,155.85,364.16Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.85,364.16a.84.84,0,0,1,0-1.59,3.05,3.05,0,0,1,2.76,0,.84.84,0,0,1,0,1.59A3.05,3.05,0,0,1,155.85,364.16Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.65,360.92a3.09,3.09,0,0,0-2.84,0,1,1,0,0,0-.58.81v1.54a1,1,0,0,0,.58.82,3.16,3.16,0,0,0,2.84,0,1,1,0,0,0,.58-.82v-1.54A1,1,0,0,0,158.65,360.92Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.65,360.92a3.09,3.09,0,0,0-2.84,0,1,1,0,0,0-.58.81v1.54a1,1,0,0,0,.58.82,3.16,3.16,0,0,0,2.84,0,1,1,0,0,0,.58-.82v-1.54A1,1,0,0,0,158.65,360.92Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13,362.37a.67.67,0,0,1,0-1.27,2.44,2.44,0,0,1,2.2,0,.67.67,0,0,1,0,1.27A2.44,2.44,0,0,1,156.13,362.37Z",
    style: {
      fill: "#00FF00",
      opacity: 0.76
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33,361.83a2.44,2.44,0,0,0-2.2,0,.27.27,0,1,0,0,.54,2.44,2.44,0,0,0,2.2,0,.27.27,0,1,0,0-.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M155.23,361.74v1.53a.86.86,0,0,0,.05.27.74.74,0,0,0-.05.29v.3a1,1,0,0,0,.58.82,2.77,2.77,0,0,0,1,.31v-.32l.24-.14v-.31l.08-.06h-.08v-1.53a3,3,0,0,1-1.26-.34A1,1,0,0,1,155.23,361.74Z",
    style: {
      fill: "#00FF00",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.07,362.46a1.41,1.41,0,0,1-.79.69,3,3,0,0,1-2.09,0,1.37,1.37,0,0,1-.79-.68,1.61,1.61,0,0,0,.83.55,3.41,3.41,0,0,0,1,.15,3.37,3.37,0,0,0,1-.15A1.55,1.55,0,0,0,159.07,362.46Z",
    style: {
      fill: "#00FF00"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.07,362.91a1.43,1.43,0,0,1-.79.68,3,3,0,0,1-2.09,0,1.37,1.37,0,0,1-.79-.68,1.61,1.61,0,0,0,.83.55,3.41,3.41,0,0,0,1,.15,3.37,3.37,0,0,0,1-.15A1.59,1.59,0,0,0,159.07,362.91Z",
    style: {
      fill: "#00FF00"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.07,363.37a1.43,1.43,0,0,1-.79.68,3.11,3.11,0,0,1-1.05.2,2.87,2.87,0,0,1-1-.2,1.37,1.37,0,0,1-.79-.68,1.55,1.55,0,0,0,.83.55,3.41,3.41,0,0,0,1,.15,3.37,3.37,0,0,0,1-.15A1.59,1.59,0,0,0,159.07,363.37Z",
    style: {
      fill: "#00FF00"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Label--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.64,381.27a7.52,7.52,0,0,1-6.82,0,2.41,2.41,0,0,1-1.41-2v4.79a2.41,2.41,0,0,0,1.41,2,7.58,7.58,0,0,0,6.82,0,2.41,2.41,0,0,0,1.41-2V379.3A2.41,2.41,0,0,1,160.64,381.27Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.05,382.89v-.29c-.21.2-.41.42-.61.63s-.51.55-.79.8A3.94,3.94,0,0,1,157,385a5.73,5.73,0,0,1-2.65-1.92c-.16-.17-.31-.35-.46-.52a6.66,6.66,0,0,0-1.46-1.4v.25a6.61,6.61,0,0,1,1.3,1.29c.15.17.3.35.46.52a5.86,5.86,0,0,0,2.76,2,4.53,4.53,0,0,0,1.07.13,4.09,4.09,0,0,0,2.79-1.12,8.73,8.73,0,0,0,.8-.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.72,384.9a4.11,4.11,0,0,1-3.72.82,5.55,5.55,0,0,1-2.75-1.81,10.47,10.47,0,0,0-1.84-1.86v1.69a2.41,2.41,0,0,0,1.41,2,7.58,7.58,0,0,0,6.82,0,2.41,2.41,0,0,0,1.41-2v-.21C161.61,384,161.21,384.49,160.72,384.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.44,381.57a5.09,5.09,0,0,1-.62-.3,2.41,2.41,0,0,1-1.41-2v4.79a2.41,2.41,0,0,0,1.41,2,5.09,5.09,0,0,0,.62.3Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--water--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.9,318.87a12.63,12.63,0,0,0-.93-2.41,2.1,2.1,0,0,0-.13-.26,5,5,0,0,1,.07-4.67s.05-.1.08-.14a5.24,5.24,0,0,0,.72-2.75,3.21,3.21,0,0,0-1.56-2.59,4.5,4.5,0,0,0-.73-.36,1.25,1.25,0,0,1-.79-1.15v-1.42l-4.55,0v1.42a1.24,1.24,0,0,1-.79,1.15,4.46,4.46,0,0,0-.73.35A3.2,3.2,0,0,0,219,308.6a5.22,5.22,0,0,0,.7,2.75l.08.14a5,5,0,0,1,0,4.67l-.13.26a13.45,13.45,0,0,0-1,2.41,11.58,11.58,0,0,0-.22,2.45l0,6.62a2.85,2.85,0,0,0,1.69,2.37,7.86,7.86,0,0,0,3.28,1,10.1,10.1,0,0,0,1.65,0,8.1,8.1,0,0,0,3.27-.93,2.88,2.88,0,0,0,1.71-2.37l0-4.78c0-.6,0-1.22,0-1.85A10.92,10.92,0,0,0,229.9,318.87Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.9,318.87a12.63,12.63,0,0,0-.93-2.41,2.1,2.1,0,0,0-.13-.26,5,5,0,0,1,.07-4.67s.05-.1.08-.14a5.24,5.24,0,0,0,.72-2.75,3.21,3.21,0,0,0-1.56-2.59,4.5,4.5,0,0,0-.73-.36,1.25,1.25,0,0,1-.79-1.15v-1.42l-4.55,0v1.42a1.24,1.24,0,0,1-.79,1.15,4.46,4.46,0,0,0-.73.35A3.2,3.2,0,0,0,219,308.6a5.22,5.22,0,0,0,.7,2.75l.08.14a5,5,0,0,1,0,4.67l-.13.26a13.45,13.45,0,0,0-1,2.41,11.58,11.58,0,0,0-.22,2.45l0,6.62a2.85,2.85,0,0,0,1.69,2.37,7.86,7.86,0,0,0,3.28,1,10.1,10.1,0,0,0,1.65,0,8.1,8.1,0,0,0,3.27-.93,2.88,2.88,0,0,0,1.71-2.37l0-4.78c0-.6,0-1.22,0-1.85A10.92,10.92,0,0,0,229.9,318.87Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.91,311.53s.05-.1.08-.14a5.17,5.17,0,0,0,.71-2.33,4,4,0,0,1-.43.94,8.86,8.86,0,0,1-2.05,2.14,3.87,3.87,0,0,0-1.74,2.36,2.93,2.93,0,0,0,1.36,2.44,23.72,23.72,0,0,1,2.39,1.67,6.24,6.24,0,0,1,.79,1,6.17,6.17,0,0,0-.12-.73,12.63,12.63,0,0,0-.93-2.41,2.1,2.1,0,0,0-.13-.26A5,5,0,0,1,228.91,311.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32,304.69v.76a1.5,1.5,0,0,0,.9,1.27,4.84,4.84,0,0,0,4.37,0,2,2,0,0,0,.68-.59,1.15,1.15,0,0,0,.23-.67v-.77a1.49,1.49,0,0,0,0-.21,1.68,1.68,0,0,0-.88-1.06l0,0a4.85,4.85,0,0,0-4.33,0,1.66,1.66,0,0,0-.88,1.05A.83.83,0,0,0,221.32,304.69Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32,304.69v.76a1.5,1.5,0,0,0,.9,1.27,4.84,4.84,0,0,0,4.37,0,2,2,0,0,0,.68-.59,1.15,1.15,0,0,0,.23-.67v-.77a1.49,1.49,0,0,0,0-.21,1.68,1.68,0,0,0-.88-1.06l0,0a4.85,4.85,0,0,0-4.33,0,1.66,1.66,0,0,0-.88,1.05A.83.83,0,0,0,221.32,304.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.59,306a1.33,1.33,0,0,0,0-2.52,4.84,4.84,0,0,0-4.37,0,1.34,1.34,0,0,0,0,2.53A4.81,4.81,0,0,0,226.59,306Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32,303.8v.46a.76.76,0,0,0,0,.21,1.63,1.63,0,0,0,.87,1.06,4.32,4.32,0,0,0,1.93.52,4.55,4.55,0,0,0,2.44-.51,2.1,2.1,0,0,0,.68-.58,1.12,1.12,0,0,0,.21-.46,1.49,1.49,0,0,0,0-.21v-.48a1.52,1.52,0,0,0-.9-1.26l-.16-.09a4.87,4.87,0,0,0-4.2.07A1.55,1.55,0,0,0,221.32,303.8Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32,303.8v.46a.76.76,0,0,0,0,.21,1.63,1.63,0,0,0,.87,1.06,4.32,4.32,0,0,0,1.93.52,4.55,4.55,0,0,0,2.44-.51,2.1,2.1,0,0,0,.68-.58,1.12,1.12,0,0,0,.21-.46,1.49,1.49,0,0,0,0-.21v-.48a1.52,1.52,0,0,0-.9-1.26l-.16-.09a4.87,4.87,0,0,0-4.2.07A1.55,1.55,0,0,0,221.32,303.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32,303.78c0,1,1.38,1.78,3.09,1.79s3.09-.78,3.09-1.76-1.37-1.79-3.08-1.79S221.33,302.8,221.32,303.78Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35,302v1.6s0,.05,0,.07a.57.57,0,0,0,.31.37,1.41,1.41,0,0,0,.66.18,1.57,1.57,0,0,0,.85-.17.83.83,0,0,0,.24-.21.46.46,0,0,0,.07-.16V302a.53.53,0,0,0-.31-.44l-.06,0a1.64,1.64,0,0,0-1.45,0A.54.54,0,0,0,223.35,302Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35,302v1.6s0,.05,0,.07a.57.57,0,0,0,.31.37,1.41,1.41,0,0,0,.66.18,1.57,1.57,0,0,0,.85-.17.83.83,0,0,0,.24-.21.46.46,0,0,0,.07-.16V302a.53.53,0,0,0-.31-.44l-.06,0a1.64,1.64,0,0,0-1.45,0A.54.54,0,0,0,223.35,302Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35,302c0,.34.48.62,1.07.62s1.07-.27,1.07-.61-.48-.61-1.07-.62S223.35,301.61,223.35,302Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,302c0,.12.17.22.38.22s.38-.1.38-.22-.17-.22-.38-.22S224,301.84,224,302Z",
    style: {
      fill: "#00FF00",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,302c0,.12.17.22.38.22s.38-.1.38-.22-.17-.22-.38-.22S224,301.84,224,302Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--indoor-bike--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bike--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.26,374.76,68.2,373a.83.83,0,0,0-.85-.06L64,374.85a1.16,1.16,0,0,0-.44,1v2.82L69.22,382l3.34-1.93v-2.82A3.09,3.09,0,0,0,71.26,374.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93,376.69l-3.06-1.77c-.71-.41-1.29,0-1.29,1v2.82L69.22,382v-2.82A3.1,3.1,0,0,0,67.93,376.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74,376.93l-3-1.72a.8.8,0,0,0-.81-.06h0L37.53,390.41h0a1.09,1.09,0,0,0-.44,1v.87l5.48,3.16L69,380.19v-.87A3,3,0,0,0,67.74,376.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.94,391.11l-3.06-1.76a.83.83,0,0,0-.85-.07l-3.33,1.93a1.14,1.14,0,0,0-.45,1v2.83l5.65,3.25,3.33-1.92v-2.83A3.1,3.1,0,0,0,42.94,391.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61,393l-3.06-1.77c-.72-.41-1.3,0-1.3,1v2.83l5.65,3.25v-2.82A3.1,3.1,0,0,0,39.61,393Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,417.14v2.05l-1.67,1v-2L93.89,402.8a25.46,25.46,0,0,0-4.83-3.05l-33.63-16-2.77-1.6,1.4-.81,36.66,17.4a25.71,25.71,0,0,1,4.84,3.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,418.11v2l-19.4-15.31a25.46,25.46,0,0,0-4.83-3l-32.23-15.3v-.17a3.27,3.27,0,0,0-1-2.23,1.27,1.27,0,0,0-.33-.24l-.09-.06,33.62,16a25.46,25.46,0,0,1,4.83,3.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,409.82l-3.05-1.76a.83.83,0,0,0-.85-.07c-.28.16-3.11,1.79-3.33,1.93a1.11,1.11,0,0,0-.45,1v2.82L130,417l3.33-1.92v-2.83A3.09,3.09,0,0,0,132,409.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.66,411.75,125.6,410c-.71-.41-1.29,0-1.29,1v2.82L130,417v-2.82A3.09,3.09,0,0,0,128.66,411.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.47,412l-3-1.71a.8.8,0,0,0-.81-.07h0L98.26,425.47h0a1.11,1.11,0,0,0-.44,1v.87l5.48,3.16,26.42-15.26v-.86A3,3,0,0,0,128.47,412Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.67,426.17l-3.06-1.76a.83.83,0,0,0-.85-.07l-3.33,1.93a1.14,1.14,0,0,0-.44,1v2.83l5.64,3.26,3.33-1.93v-2.82A3.12,3.12,0,0,0,103.67,426.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.34,428.1l-3.06-1.76c-.72-.42-1.29,0-1.29,1v2.83l5.64,3.26v-2.83A3.1,3.1,0,0,0,100.34,428.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.68,356.81l2.42-.37h0a21.85,21.85,0,0,1,6.34,10.3l14.15,50.7-3-1.74L102,367.11a22,22,0,0,0-6.34-10.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.59,417.44l-14.14-50.7a22,22,0,0,0-6.35-10.3h0l-1-3.18L99,355a22,22,0,0,1,6.23,10.19l14.41,51.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2,359l-1.81-6.51c-6,1.71-10.72,3.09-15.41,6a46.56,46.56,0,0,0-12.21,10c-5.22,5.7-11.12,12.56-13.24,15.83l6.13,2.91,1.68-1c2.12-3.27,4.07-5.8,9.29-11.51a55.38,55.38,0,0,1,11.75-10.21A56.8,56.8,0,0,1,97.53,360Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.39,352.47l-1.67,1c-5.31,1.5-9.55,2.75-13.68,5C86.71,355.55,91.36,354.17,97.39,352.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.53,384.31l6.13,2.91c2.13-3.27,4.08-5.8,9.3-11.5,9.29-10.15,15.21-12.85,25.57-15.77l-1.81-6.52c-10.36,2.92-16.66,4.9-25.95,15.05C64.55,374.18,58.65,381,56.53,384.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.47 363.57 86.12 362.41 85.55 361.03 91.34 359.2 92.38 362.28 88.47 363.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.12 362.41 91.81 360.6 92.38 362.28 88.47 363.57 86.12 362.41",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.34,360.27c0,.23-.14.34-.32.23a.76.76,0,0,1-.31-.6c0-.23.14-.34.31-.24A.75.75,0,0,1,91.34,360.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,361.7c0,.23-.14.34-.31.24a.74.74,0,0,1-.32-.6c0-.24.14-.34.32-.24A.76.76,0,0,1,86.7,361.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38,395.19c0-8.88-5.4-19.19-12.06-23-3-1.74-5.78-1.85-7.89-.63l-3.35,1.93c-2.54,1.48-4.15,4.89-4.15,9.74,0,8.88,5.4,19.19,12.06,23,3,1.74,5.77,1.85,7.89.63l3.34-1.92C113.77,403.46,115.38,400.05,115.38,395.19Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38,395.19c0-8.88-5.4-19.19-12.06-23-3-1.74-5.78-1.85-7.89-.63l-3.35,1.93c-2.54,1.48-4.15,4.89-4.15,9.74,0,8.88,5.4,19.19,12.06,23,3,1.74,5.77,1.85,7.89.63l3.34-1.92C113.77,403.46,115.38,400.05,115.38,395.19Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.99,
    cy: 390.15,
    rx: 10.47,
    ry: 18.51,
    transform: "translate(-144.78 70.3) rotate(-23.05)",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.99,
    cy: 390.15,
    rx: 10.47,
    ry: 18.51,
    transform: "translate(-144.78 70.3) rotate(-23.05)",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.99,
    cy: 390.15,
    rx: 8.16,
    ry: 14.43,
    transform: "translate(-144.78 70.3) rotate(-23.05)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.59,393.38c0,4.13-2.51,6-5.6,4.24s-5.6-6.58-5.6-10.71,2.5-6,5.6-4.23S105.59,389.26,105.59,393.38Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.22,398.5a4.73,4.73,0,0,1-2.33-.7c-3.15-1.82-5.71-6.7-5.71-10.89,0-2.24.74-4,2-4.71a3.8,3.8,0,0,1,3.87.3c3.15,1.82,5.71,6.7,5.71,10.88,0,2.25-.75,4-2,4.71A3.06,3.06,0,0,1,102.22,398.5Zm-4.46-16.29a2.71,2.71,0,0,0-1.34.35c-1.16.67-1.83,2.26-1.83,4.35,0,4.06,2.47,8.78,5.5,10.53a3.41,3.41,0,0,0,3.46.3c1.17-.68,1.84-2.26,1.84-4.36,0-4.05-2.47-8.77-5.5-10.52A4.32,4.32,0,0,0,97.76,382.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,374.07a18.69,18.69,0,0,1,5.18,4.32,28.69,28.69,0,0,1,3.74,5.65,30.82,30.82,0,0,1,2.37,6.36l.36,1.65.27,1.68.13,1.69v1.69l-.12-1.68-.22-1.67-.32-1.65-.41-1.63a33.86,33.86,0,0,0-2.43-6.25,30.59,30.59,0,0,0-3.62-5.64c-.34-.45-.73-.85-1.1-1.27a16.56,16.56,0,0,0-1.19-1.18l-.3-.29-.33-.27-.65-.54a6.94,6.94,0,0,0-.68-.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.47,363.57c6.22,5.79,15,11.7,17.66,11.11L105,370.75c-1.31.76-7.81-4.41-11.05-9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.13,374.68a.89.89,0,0,0,.05-.59l-1.42-5,.25,1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.52,359.2,94,361.76c3.24,4.58,9.74,9.75,11.05,9h0C104.92,367.76,102.81,364.71,98.52,359.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.75 391.2 65.71 346.45 62.96 346.08 61.29 347.05 70.14 390.77 73.08 392.16 74.75 391.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.29 347.05 62.96 346.08 65.71 346.45 64.04 347.42 61.29 347.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.14 390.77 61.29 347.05 64.04 347.42 73.08 392.16 70.14 390.77",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.22 346.39 63.2 336.37 61.04 335.13 59.54 335.99 61.77 346.99 63.73 347.25 65.22 346.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.7 337.24 59.54 335.99 61.77 346.99 63.73 347.25 61.7 337.24",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.2 336.37 61.04 335.13 59.54 335.99 60.23 339.39 62.39 340.64 63.89 339.78 63.2 336.37",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.52 336.67 56.78 329.31 53.45 331.23 53.45 333.28 66.19 340.64 69.52 338.72 69.52 336.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.19 338.59 53.45 331.23 53.45 333.28 66.19 340.64 66.19 338.59",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.19 338.59 69.52 336.67 56.78 329.31 53.45 331.23 66.19 338.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.43 333.25 58.87 320.59 56.71 319.34 55.21 320.21 57.77 332.86 59.94 334.11 61.43 333.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.38 321.45 55.21 320.21 57.77 332.86 59.94 334.11 57.38 321.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.87 320.59 56.71 319.34 55.21 320.21 55.9 323.61 58.06 324.86 59.56 323.99 58.87 320.59",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.44,319.56a31.85,31.85,0,0,0-3.27-4.51s-5.84-9.13-13.28-5.5a4.77,4.77,0,0,0-2.73,3.35,6,6,0,0,0-.16,1.55,3.75,3.75,0,0,0,.73,2.24c.85,1.37,3.44,2.62,6.58,3.65l.67.22c1.12.34,2.26.64,3.38.95s2.24.62,3.34,1c.45.15.9.32,1.33.51.18.09.36.17.53.27a2.74,2.74,0,0,0,.6.27,1.56,1.56,0,0,0,.57.06,2.15,2.15,0,0,0,.44-.09,1.27,1.27,0,0,0,.37-.18,2.64,2.64,0,0,0,1-1.18A3,3,0,0,0,64.44,319.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.89,309.55c-2.26,1.1-3.61,3.33-2.07,5.8.85,1.37,3.44,2.62,6.58,3.65s8.54,2.14,9.81,3.33,3.34-.65,2.23-2.77a31.85,31.85,0,0,0-3.27-4.51S55.33,305.92,47.89,309.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.91,395.14l-3.52-12.63s-4.46-3.76-8.14-6.62-15.71-11.84-20.73-14.73c-2-1.16-3.84-1.24-5.25-.42l-3.34,1.92c-1.7,1-2.78,3.27-2.78,6.51,0,5.92,3.6,12.8,8,15.36,5.49,3.17,12.56,5.53,17.77,7.52s14.62,5,14.62,5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.06 384.43 99.39 382.51 102.91 395.14 99.58 397.06 96.06 384.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.06,384.43s-4.46-3.76-8.15-6.62S72.2,366,67.19,363.08c-4.44-2.56-8,.16-8,6.09s3.6,12.8,8,15.36c5.49,3.17,12.56,5.53,17.77,7.52s14.62,5,14.62,5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.34,383.15c-3.85-2.2-7.1-8.25-7.09-13.38s3.12-7.42,6.94-5.22c4.75,2.75,15.71,11,19.78,14.34,3.09,2.53,6.53,5.67,8.14,7.07a2.3,2.3,0,0,1,.67,1.12l2,7.11c.12.45,0,.78-.35.68-3-1-8.92-2.95-12.62-4.36l-3.07-1.15A100.24,100.24,0,0,1,67.34,383.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1,386.88a5.19,5.19,0,0,0-1.82-2.7c-2.06-1.6-6-4.64-8.71-6.56l-2.2-1.53c-4.15-2.86-10.12-6.81-10.23-6.89h0a8,8,0,0,0-.16,1.6c0,3.84,2.33,8.29,5.21,9.95l.13.08c5.58,3.17,18.26,7.77,18.26,7.77Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1,386.88a5.19,5.19,0,0,0-1.82-2.7c-2.06-1.6-6-4.64-8.71-6.56l-2.2-1.53c-4.15-2.86-10.12-6.81-10.23-6.89h0a8,8,0,0,0-.16,1.6c0,3.84,2.33,8.29,5.21,9.95l.13.08c5.58,3.17,18.26,7.77,18.26,7.77Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.61,375.78c0,2.52-1.53,3.68-3.42,2.59a8.19,8.19,0,0,1-3.42-6.53c0-2.52,1.53-3.68,3.42-2.59A8.19,8.19,0,0,1,70.61,375.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6,375.2c0,1.77-1.08,2.59-2.41,1.82a5.77,5.77,0,0,1-2.41-4.6c0-1.77,1.08-2.59,2.41-1.82A5.77,5.77,0,0,1,69.6,375.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.26,374.82c0,1.08-.66,1.58-1.47,1.11a3.51,3.51,0,0,1-1.46-2.8c0-1.07.65-1.57,1.46-1.1A3.5,3.5,0,0,1,68.26,374.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75,388.44l-.1,0c-.12,0-12.73-4.62-18.23-7.75l-.13-.07c-2.81-1.63-5.1-6-5.1-9.78,0-1.94.62-3.41,1.7-4a3.16,3.16,0,0,1,3.2.27c2.22,1.28,4.16,2.56,6.22,3.92l.46.3a2.42,2.42,0,0,0,3-.24l.8-.74a.58.58,0,0,1,.15-.11L81,368.26l-.37-.26-3.15,1.82a1.12,1.12,0,0,0-.22.16l-.8.74a2,2,0,0,1-2.47.19l-.45-.3c-2.07-1.35-4-2.64-6.25-3.92a3.53,3.53,0,0,0-3.61-.28c-1.21.7-1.9,2.3-1.9,4.39,0,3.9,2.38,8.44,5.31,10.13l.13.08c5.27,3,17,7.31,18.19,7.74l1.13,3.89.47.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.11,384.68c0,.31-.19.46-.42.32a1,1,0,0,1-.43-.8c0-.31.19-.45.43-.32A1,1,0,0,1,95.11,384.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.83,395.9c0,.31-.19.45-.42.32a1,1,0,0,1-.42-.8c0-.31.19-.46.42-.32A1,1,0,0,1,98.83,395.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.89,375.06l-.29.22a5.83,5.83,0,0,0,.37.7l.29-.21c.1-.08.1-.3,0-.5S65,375,64.89,375.06Zm-.7-3.33-.41-.24c0,.12,0,.23,0,.35s0,.23,0,.35l.41.24c.15.08.27,0,.27-.2A.62.62,0,0,0,64.19,371.73Zm3,5.73c-.14-.09-.26,0-.26.2v.54l.26.17.26.13V378A.6.6,0,0,0,67.19,377.46Zm1.94.05c-.11.07-.11.29,0,.49l.28.55a1.44,1.44,0,0,0,.37-.28l-.28-.55C69.39,377.52,69.23,377.43,69.13,377.51Zm1.47-2.08-.41-.24c-.15-.08-.26,0-.26.2a.61.61,0,0,0,.26.5l.41.23c0-.11,0-.22,0-.34S70.6,375.55,70.6,375.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6,374.45c0,.59-.36.87-.81.61a2,2,0,0,1-.81-1.55c0-.59.37-.87.81-.61A1.93,1.93,0,0,1,67.6,374.45Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,355.34l.12,4.57a39.72,39.72,0,0,0,1.46,9.63l14.17,50.84,3,1.74,1-.6-14.5-52a40,40,0,0,1-1.45-9.66h0L94.18,355Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,404.33c.84,2.65,1.63,5.32,2.38,8,.39,1.33.75,2.67,1.11,4s.73,2.68,1.08,4l0-.06c1,.6,2,1.21,3,1.82-1-.54-2-1.09-3.06-1.66h0v0c-.4-1.33-.79-2.66-1.17-4s-.76-2.67-1.12-4C104.4,409.72,103.69,407,103,404.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.55,421.52l-14.5-52a40,40,0,0,1-1.45-9.66L94.18,355l.12,4.56a40,40,0,0,0,1.46,9.65l14.76,52.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.55,421.52q-2.19-7.66-4.34-15.34l-4.32-15.36-4.26-15.37-1.06-3.84c-.35-1.28-.73-2.56-1-3.86a38.3,38.3,0,0,1-1-7.91h0L94.18,355l1.44,4.87h0a41.09,41.09,0,0,0,1,7.89c.3,1.29.69,2.56,1,3.84l1.08,3.84,4.3,15.36,4.25,15.37Q109.48,413.82,111.55,421.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.49,375.92a.6.6,0,0,1-.51-.27l-8.33-12.51a.61.61,0,1,1,1-.68l8,12,1.58-.92a.61.61,0,0,1,.84.23.62.62,0,0,1-.22.84l-2.08,1.2A.6.6,0,0,1,64.49,375.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.16,365.81l-7.4-7.56a.86.86,0,0,0-.83-.23l-7.49,1.92a.89.89,0,0,0-.62.6l-.11.42a.85.85,0,0,0,.21.83l7.42,7.57a.85.85,0,0,0,.83.23l7.48-1.93a.84.84,0,0,0,.61-.6l.12-.42A.86.86,0,0,0,61.16,365.81Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.16,365.81l-7.4-7.56a.86.86,0,0,0-.83-.23l-7.49,1.92a.89.89,0,0,0-.62.6l-.11.42a.85.85,0,0,0,.21.83l7.42,7.57a.85.85,0,0,0,.83.23l7.48-1.93a.84.84,0,0,0,.61-.6l.12-.42A.86.86,0,0,0,61.16,365.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.74,368a.81.81,0,0,0,.78.22l7.86-2a.9.9,0,0,0-.22-.39l-2.85-2.91-4.55-4.65a.86.86,0,0,0-.83-.23l-.91.23-6.58,1.69a.84.84,0,0,0-.39.22Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--handlebar--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,334.25l-2.6-.35L91,335.29l6.28,29c1.13,1.11,2.21,2.23,3.25,3.34l2.39-1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.55 335.64 95.95 334.25 93.35 333.9 90.95 335.29 93.55 335.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,335.29l6.28,29c1.13,1.11,2.21,2.23,3.25,3.34l-6.93-32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.25 334.42 92.21 320.42 90.16 320.15 88.49 321.11 91.55 335.11 93.59 335.38 95.25 334.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.49 321.11 91.55 335.11 93.59 335.38 90.54 321.38 88.49 321.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.57,330.06l-.22,0c-1.49-.26-1.86-1.1-1.95-1.57a2.06,2.06,0,0,1,1.28-2.16l25-14.43a7.72,7.72,0,0,1,4.65-.83l8.69,1.49a.58.58,0,0,0,.69-.35l5.71-9.91a1.28,1.28,0,0,1,1.74-.46,1.27,1.27,0,0,1,.47,1.73l-5.72,9.91a3.11,3.11,0,0,1-3.32,1.59l-8.7-1.5a5.34,5.34,0,0,0-2.94.53l-24.3,14a1.32,1.32,0,0,1,.17.88A1.28,1.28,0,0,1,71.57,330.06Zm.21-1.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.12 304.26 89.13 310.03 84.13 324.46 85.8 325.42 95.79 319.65 100.79 305.22 99.12 304.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.8 325.42 90.79 310.99 100.79 305.22 95.79 319.65 85.8 325.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.13 310.03 90.79 310.99 85.8 325.42 84.13 324.46 89.13 310.03",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.63,331.59a4,4,0,0,1-.59,0L71.35,330a1.27,1.27,0,1,1,.43-2.51l8.69,1.5a.6.6,0,0,0,.7-.35l5.71-9.91a1.27,1.27,0,1,1,2.2,1.27L83.37,330A3.12,3.12,0,0,1,80.63,331.59Z",
    style: {
      fill: "#37474f"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymAmico);
export default __webpack_public_path__ + "static/media/Gym-amico.0715c776ea43c33fd644ba74de572733.svg";
export { ForwardRef as ReactComponent };